/* ============================================================
   Gymbuild – Mouse vs Keyboard focus handling (accessible)
   ============================================================ */
(function () {
  const body = document.body;
  if (!body) return;

  function setMouseMode() {
    body.classList.add('using-mouse');
  }

  function setKeyboardMode(e) {
    // When user tabs, switch to keyboard mode (show focus rings)
    if (e.key === 'Tab') body.classList.remove('using-mouse');
  }

  // Mouse / touch => hide click focus rings
  window.addEventListener('mousedown', setMouseMode, true);
  window.addEventListener('pointerdown', setMouseMode, true);
  window.addEventListener('touchstart', setMouseMode, true);

  // Keyboard (Tab) => show focus rings
  window.addEventListener('keydown', setKeyboardMode, true);
})();





































/* ============================================================
   Gymbuild – Search Focus Glass State
   Desktop only
   Uses the same open-glass/shadow visual state as the dropdown
   while the search bar is actively focused.

   Behavior:
   - Click/focus search: enable search glass
   - Hover/open megamenu: megamenu visually takes over via CSS, but the
     search glass state is kept active in the background
   - Leave/close megamenu while search is still focused: search glass remains
     active immediately with no brief normal-glass flash
   - Scroll: reset search glass until user physically clicks search again
   - Click outside search: default browser focus behavior + reset glass
   ============================================================ */
(function () {
  const desktopQuery = window.matchMedia('(min-width: 720px)');
  const body = document.body;

  if (!body || body.classList.contains('gb-search-glass-ready')) return;

  body.classList.add('gb-search-glass-ready');

  const ACTIVE_CLASS = 'gb-search-glass-active';

  let searchForm = null;
  let searchInput = null;
  let scrollSuppressed = false;

  function isDesktop() {
    return desktopQuery.matches;
  }

  function refreshSearchElements() {
    searchForm = document.querySelector('.site-header .live-search-form');
    searchInput = searchForm
      ? searchForm.querySelector('[data-live-search-input], .live-search-form-field')
      : null;
  }

  function isInsideSearch(target) {
    return Boolean(searchForm && target && searchForm.contains(target));
  }

  function activeElementIsInsideSearch() {
    return Boolean(searchForm && document.activeElement && searchForm.contains(document.activeElement));
  }

  function enableSearchGlass() {
    if (!isDesktop()) return;

    refreshSearchElements();

    if (!searchForm || scrollSuppressed) return;

    /*
      Keep this class even while a megamenu is open.
      CSS has :not(.gb-header-menu-open), so dropdown glass visually takes over.
      Keeping the class active prevents a brief flash back to normal glass
      when the dropdown closes while search is still focused.
    */
    body.classList.add(ACTIVE_CLASS);
  }

  function disableSearchGlass() {
    body.classList.remove(ACTIVE_CLASS);
  }

  function onFocusIn(event) {
    if (!isDesktop()) return;

    refreshSearchElements();

    if (isInsideSearch(event.target)) {
      scrollSuppressed = false;
      enableSearchGlass();
    }
  }

  function onFocusOut() {
    if (!isDesktop()) return;

    window.setTimeout(() => {
      if (!activeElementIsInsideSearch()) {
        scrollSuppressed = false;
        disableSearchGlass();
      }
    }, 0);
  }

  function onPointerDown(event) {
    if (!isDesktop()) return;

    refreshSearchElements();

    if (isInsideSearch(event.target)) {
      /*
        A physical click inside search reactivates the glass state even if
        scrolling previously reset the visual effect.
      */
      scrollSuppressed = false;
      enableSearchGlass();
      return;
    }

    scrollSuppressed = false;
    disableSearchGlass();
  }

  function onKeyDown(event) {
    if (!isDesktop()) return;

    if (event.key === 'Escape') {
      disableSearchGlass();
    }
  }

  function onScrollIntent() {
    if (!isDesktop()) return;

    if (body.classList.contains(ACTIVE_CLASS) || activeElementIsInsideSearch()) {
      /*
        Scrolling means the user has moved away from search focus visually.
        Do not blur the input, but do not restore the search glass again until
        the user physically clicks the search bar.
      */
      scrollSuppressed = true;
      disableSearchGlass();
    }
  }

  function onMenuStateChange() {
    if (!isDesktop()) return;

    /*
      If search is still the active focused element and the user has not
      scrolled away, keep the search-glass state active. During dropdown open,
      CSS temporarily suppresses it with :not(.gb-header-menu-open); when the
      dropdown closes, it is already ready, so no normal-glass flash occurs.
    */
    if (activeElementIsInsideSearch() && !scrollSuppressed) {
      enableSearchGlass();
    }
  }

  function attachSearchGlassController() {
    refreshSearchElements();

    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('focusout', onFocusOut, true);
    document.addEventListener('pointerdown', onPointerDown, true);
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('gb:menu-state-change', onMenuStateChange);

    window.addEventListener('scroll', onScrollIntent, { passive: true });
    window.addEventListener('wheel', onScrollIntent, { passive: true });
    window.addEventListener('touchmove', onScrollIntent, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSearchGlassController);
  } else {
    attachSearchGlassController();
  }

  function handleSearchLayoutChange() {
    if (isDesktop()) {
      return;
    }

    /*
      Landscape -> portrait search cleanup.

      iOS/Empire can keep the landscape live-search dimming state
      active after the viewport crosses back into portrait.

      Do not clear the customer's query.

      Instead:
      1. Preserve the current search text.
      2. Ask Empire to dismiss its active search state with Escape.
      3. Release input focus.
      4. Send an outside click so Empire completes its normal
        search-dismiss cleanup.
      5. Restore the query if Empire changed it.
    */

    refreshSearchElements();

    const input =
      searchInput;

    const preservedValue =
      input
        ? input.value
        : '';

    scrollSuppressed = false;
    disableSearchGlass();


    if (input) {

      /*
        Let Empire's own search controller receive its normal
        dismiss command.
      */

      input.dispatchEvent(
        new KeyboardEvent(
          'keydown',
          {
            key: 'Escape',
            code: 'Escape',
            keyCode: 27,
            which: 27,
            bubbles: true,
            cancelable: true
          }
        )
      );


      /*
        Release the landscape search focus.
      */

      if (
        document.activeElement === input
      ) {
        input.blur();
      }
    }


    /*
      Complete Empire's normal outside-search dismissal.

      Target the page container itself rather than another
      interactive control.
    */

    const outsideTarget =
      document.querySelector(
        '.site-main, main, #MainContent'
      ) ||
      document.body;

    if (outsideTarget) {
      outsideTarget.dispatchEvent(
        new MouseEvent(
          'click',
          {
            bubbles: true,
            cancelable: true,
            view: window
          }
        )
      );
    }


    /*
      Preserve whatever the customer had typed.
    */

    if (
      input &&
      input.value !== preservedValue
    ) {
      input.value =
        preservedValue;
    }


    /*
      Safari can finish its responsive header handoff
      shortly after the media-query change. Run the
      non-destructive cleanup once more after that handoff.
    */

    window.setTimeout(
      function () {

        scrollSuppressed = false;
        disableSearchGlass();

        if (
          input &&
          document.activeElement === input
        ) {
          input.blur();
        }


        if (
          input &&
          input.value !== preservedValue
        ) {
          input.value =
            preservedValue;
        }

      },
      120
    );
  }


  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener(
      'change',
      handleSearchLayoutChange
    );
  } else {
    desktopQuery.addListener(
      handleSearchLayoutChange
    );
  }
})();





































/* ============================================================
   Gymbuild – Custom Desktop Glass Menu Controller
   Desktop only
   Owns visible menu open/switch/close behavior
   Slower open/close timing
   Closes menu on page scroll
   Keeps menu open inside nav row + full visual dropdown safe zone
   Removes Empire's visible ghost handoff bounce
   ============================================================ */
(function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const root = document.documentElement;
  const body = document.body;

  if (!body || !root) return;

  /*
    Timing strategy:
    - Opening and closing keep the longer hover-intent delay so the megamenu
      does not feel too sensitive when the cursor passes near the nav.
    - Switching between already-open dropdown tabs is intentionally much faster,
      closer to the native Empire-style feel.
    - Open fade-in is almost immediate and starts partially visible so the swipe is visible.
    - Close fade-out stays synced with the swipe/panel motion so the upward movement does not outlast the dropdown.
    - Switching uses one matched quick fade speed for both out and in.
  */
  const OPEN_CLOSE_INTENT_DELAY = 210;
  const SWITCH_OPEN_DELAY = 30;

  const OPEN_CLOSE_EXIT_DURATION = 210;
  const SWITCH_FADE_DURATION = 35;
  const SWITCH_FADE_OUT_DURATION = SWITCH_FADE_DURATION;
  const SWITCH_FADE_IN_DURATION = SWITCH_FADE_DURATION;
  const SWITCH_REVEAL_DELAY = SWITCH_FADE_DURATION;
  const SWITCH_EXIT_DURATION = (SWITCH_FADE_DURATION * 2) + 30;

  /*
    Chevron switch sequencing:
    - The previous tab's chevron returns to the resting down position first.
    - After that transition finishes, the newly hovered tab's chevron flattens.
    This only affects chevrons during tab switching; menu content still switches quickly.
  */
  const CHEVRON_TRANSITION_DURATION = 135;
  const CHEVRON_SWITCH_DELAY = CHEVRON_TRANSITION_DURATION + 20;

  const CLOSE_DELAY = OPEN_CLOSE_INTENT_DELAY;

  /*
    Hover intent delay prevents dropdowns from opening when a customer
    quickly glances or swipes across the navigation row.
  */
  const INITIAL_OPEN_DELAY = OPEN_CLOSE_INTENT_DELAY;

  /*
    Safe-zone padding fixes:
    - tiny gap between nav row and dropdown
    - blank left/right glass areas inside the full-width dropdown field
  */
  const SAFE_ZONE_GAP = 12;
  const SCROLL_RESET_CLASS = 'gb-header-menu-scroll-reset';

  let nav = null;
  let header = null;
  let items = [];
  let activeItem = null;
  let openTimer = null;
  let pendingOpenItem = null;
  let closeTimer = null;
  let switchTimer = null;
  let switchRevealTimer = null;
  let openMotionTimer = null;
  let closeMotionTimer = null;
  let closeClipFrame = null;
  let chevronSwitchTimer = null;
  let heightExpandTimer = null;
  let heightRevealTimer = null;
  let scrollResetReopenTimer = null;
  let frame = null;
  let pointerFrame = null;
  let isScrollClosing = false;

  let lastPointerX = null;
  let lastPointerY = null;
  let manualUntuckHoverWatchUntil = 0;
  let underPointerTimers = [];
  let menuHeightCache = new WeakMap();

  function isDesktop() {
    return desktopQuery.matches;
  }

  function getHeader() {
    return document.querySelector('[data-site-header]');
  }

  function getNav() {
    return document.querySelector('#site-header-nav .site-navigation');
  }

  function getDetails(item) {
    return item ? item.querySelector(':scope > details') : null;
  }

  function getMenu(item) {
    return item
      ? item.querySelector(':scope > details > .navmenu-submenu')
      : null;
  }

  function getSummary(item) {
    return item
      ? item.querySelector(':scope > details > .navmenu-link-depth-1')
      : null;
  }

  function getTopLevelLabel(item) {
    const summary = getSummary(item);

    return summary
      ? summary.textContent.replace(/\s+/g, ' ').trim().toLowerCase()
      : '';
  }

  function shouldAlignMenuUnderTrigger(item) {
    /*
      Strength keeps the custom full-width / multi-column layout.
      Other dropdown headings align their dropdown content under their own tab.
    */
    return Boolean(item && getTopLevelLabel(item) !== 'strength');
  }

  function getTopLevelHref(item, target) {
    const summary = getSummary(item);
    const details = getDetails(item);

    if (!summary || !details) return null;

    /*
      Some Empire nav structures use an <a> for the top-level item.
      Others use a <summary> with an anchor inside it.
      This keeps desktop dropdown hover behavior, but makes the first click
      on the top-level dropdown label navigate instead of only toggling details.
    */
    const clickedAnchor = target && target.closest ? target.closest('a[href]') : null;

    if (clickedAnchor && summary.contains(clickedAnchor)) {
      return clickedAnchor.href || clickedAnchor.getAttribute('href');
    }

    if (summary.matches && summary.matches('a[href]')) {
      return summary.href || summary.getAttribute('href');
    }

    const innerAnchor = summary.querySelector ? summary.querySelector('a[href]') : null;

    if (innerAnchor) {
      return innerAnchor.href || innerAnchor.getAttribute('href');
    }

    const directAnchor = details.querySelector(
      ':scope > a.navmenu-link-depth-1[href], :scope > a[href]'
    );

    if (directAnchor) {
      return directAnchor.href || directAnchor.getAttribute('href');
    }

    return (
      summary.getAttribute('href') ||
      summary.getAttribute('data-href') ||
      summary.getAttribute('data-url') ||
      null
    );
  }

  function shouldOpenInNewTab(event) {
    return Boolean(
      event &&
      (
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button === 1
      )
    );
  }

  function navigateToTopLevelHref(href, event) {
    if (!href || href === '#') return;

    if (shouldOpenInNewTab(event)) {
      window.open(href, '_blank', 'noopener');
      return;
    }

    window.location.href = href;
  }

  function rememberPointerPosition(event) {
    if (
      event &&
      typeof event.clientX === 'number' &&
      typeof event.clientY === 'number'
    ) {
      lastPointerX = event.clientX;
      lastPointerY = event.clientY;
    }
  }

  function isInsideNavMenuArea(target) {
    return Boolean(nav && target && nav.contains(target));
  }

  function getElementUnderPointer() {
    if (lastPointerX === null || lastPointerY === null) return null;

    return document.elementFromPoint(lastPointerX, lastPointerY);
  }

  function isInsideTopNavRow(target) {
    return Boolean(nav && target && nav.contains(target));
  }

  function isPointerCurrentlyInsideTopNavRow() {
    return isInsideTopNavRow(getElementUnderPointer());
  }

  function clearScrollResetReopenTimer() {
    if (scrollResetReopenTimer) {
      window.clearTimeout(scrollResetReopenTimer);
      scrollResetReopenTimer = null;
    }
  }

  function startScrollHoverReset() {
    clearScrollResetReopenTimer();
    body.classList.add(SCROLL_RESET_CLASS);
  }

  function clearScrollHoverReset() {
    clearScrollResetReopenTimer();
    body.classList.remove(SCROLL_RESET_CLASS);
  }

  function isScrollHoverResetActive() {
    return body.classList.contains(SCROLL_RESET_CLASS);
  }

  function pointerCameFromInsideTopNav(event) {
    return Boolean(
      event &&
      event.relatedTarget &&
      nav &&
      nav.contains(event.relatedTarget)
    );
  }

  function pointerMovedOutsideTopNav(event) {
    if (!isScrollHoverResetActive() || !nav) return false;

    /*
      During sticky/header movement, event.target can be stale or misleading.
      Use the actual element currently under the pointer so reset clears once
      the pointer really leaves the nav row.
    */
    return !isPointerCurrentlyInsideTopNavRow();
  }

  function getDropdownItemFromTarget(target) {
    const item = target && target.closest
      ? target.closest('.site-navigation .navmenu-depth-1 > li')
      : null;

    return item && items.includes(item) ? item : null;
  }

  function getDropdownItemUnderPointer() {
    return getDropdownItemFromTarget(getElementUnderPointer());
  }

  function isPointerInsideRect(rect, gap = 0) {
    if (!rect || lastPointerX === null || lastPointerY === null) {
      return false;
    }

    return (
      lastPointerX >= rect.left - gap &&
      lastPointerX <= rect.right + gap &&
      lastPointerY >= rect.top - gap &&
      lastPointerY <= rect.bottom + gap
    );
  }

  function isPointerInsideDropdownTrigger() {
    if (!items.length) return false;

    /*
      Use live trigger positions here instead of cached rectangles.
      The nav row can move during sticky tuck/untuck and manual hamburger
      animations; stale cached positions can make the controller think the
      pointer left the trigger and close the dropdown immediately.
    */
    return items.some((item) => {
      const summary = getSummary(item);

      if (!summary) return false;

      return isPointerInsideRect(summary.getBoundingClientRect(), SAFE_ZONE_GAP);
    });
  }

  function isPointerInsideActiveMenuPanel() {
    if (!activeItem) return false;

    const menu = getMenu(activeItem);

    if (!menu) return false;

    const navRect = nav ? nav.getBoundingClientRect() : null;
    const menuRect = menu.getBoundingClientRect();
    const headerRect = header ? header.getBoundingClientRect() : menuRect;
    const activeMenuHeight = getMenuHeight(activeItem);

    /*
      Keep the menu open while the pointer is inside the visible dropdown
      panel/glass field. This preserves normal dropdown usability.
    */
    const panelTop = navRect ? navRect.bottom - SAFE_ZONE_GAP : menuRect.top - SAFE_ZONE_GAP;
    const panelBottom = navRect
      ? navRect.bottom + activeMenuHeight + SAFE_ZONE_GAP
      : menuRect.bottom + SAFE_ZONE_GAP;

    return (
      lastPointerX >= headerRect.left - SAFE_ZONE_GAP &&
      lastPointerX <= headerRect.right + SAFE_ZONE_GAP &&
      lastPointerY >= panelTop &&
      lastPointerY <= panelBottom
    );
  }

  function isPointerInsideVisualMenuSafeZone() {
    if (!nav || lastPointerX === null || lastPointerY === null) {
      return false;
    }

    const navRect = nav.getBoundingClientRect();

    /*
      Nav row rule:
      only the real nav row itself uses trigger-only behavior.
      This keeps blank nav-row space and non-dropdown links from holding
      the menu open, but it no longer treats the empty space below the nav
      row as part of the nav row.

      That below-nav space belongs to the dropdown panel/glass field, so
      users can move from the heading down into the menu content without
      the controller closing the dropdown.
    */
    if (
      lastPointerY >= navRect.top - SAFE_ZONE_GAP &&
      lastPointerY <= navRect.bottom
    ) {
      return isPointerInsideDropdownTrigger();
    }

    /*
      Dropdown panel rule:
      once opened, the visible dropdown panel remains a safe zone so users can
      move from the top nav item into the menu content without it closing.
    */
    return isPointerInsideActiveMenuPanel();
  }

  function getNow() {
    return performance.now ? performance.now() : Date.now();
  }

  function clearUnderPointerTimers() {
    underPointerTimers.forEach((timer) => {
      window.clearTimeout(timer);
    });

    underPointerTimers = [];
  }

  function isManualUntuckHoverWatchActive() {
    return getNow() < manualUntuckHoverWatchUntil;
  }

  function openDropdownUnderPointer() {
    if (
      !isDesktop() ||
      !nav ||
      !items.length ||
      lastPointerX === null ||
      lastPointerY === null
    ) {
      return;
    }

    const navRect = nav.getBoundingClientRect();

    /*
      Only auto-open if the pointer is sitting over the nav row.
      This fixes the manual hamburger/X untuck case where the nav appears
      underneath an already-stationary pointer and no pointerover event fires.
    */
    if (
      lastPointerY < navRect.top - SAFE_ZONE_GAP ||
      lastPointerY > navRect.bottom + SAFE_ZONE_GAP
    ) {
      return;
    }

    const element = document.elementFromPoint(lastPointerX, lastPointerY);
    const item = element
      ? element.closest('.site-navigation .navmenu-depth-1 > li')
      : null;

    if (item && items.includes(item)) {
      scheduleOpenItem(item, INITIAL_OPEN_DELAY);
    } else if (activeItem) {
      clearOpenTimer();
      closeMenu();
    } else {
      clearOpenTimer();
    }
  }

  function scheduleOpenDropdownUnderPointer() {
    if (!isDesktop()) return;

    clearUnderPointerTimers();

    /*
      Run multiple checks because the nav row is animating into place.
      This catches the case where the pointer stops over a dropdown trigger
      before that trigger becomes hit-testable.
    */
    window.requestAnimationFrame(openDropdownUnderPointer);

    [60, 120, 190, 270, 360].forEach((delay) => {
      underPointerTimers.push(window.setTimeout(openDropdownUnderPointer, delay));
    });
  }

  function startManualUntuckHoverWatch() {
    manualUntuckHoverWatchUntil = getNow() + 650;
    scheduleOpenDropdownUnderPointer();
  }

  function collectItems() {
    if (!nav) return [];

    return Array.from(nav.querySelectorAll('.navmenu-depth-1 > li'))
      .filter((item) => getDetails(item) && getMenu(item));
  }

  function clearMenuMotionLayers(item) {
    const menu = getMenu(item);

    if (!menu) return;

    menu.querySelectorAll('.gb-menu-motion-layer').forEach((layer) => {
      layer.classList.remove('gb-menu-motion-layer');
    });
  }

  function prepareMenuMotionLayers(item) {
    const menu = getMenu(item);

    if (!menu) return;

    clearMenuMotionLayers(item);

    /*
      Build a dedicated motion layer for open/close animation.
      We do not animate the outer .navmenu-submenu panel because that layer
      controls full-width positioning, visibility, height, pointer behavior,
      and the dropdown safe zone.
    */
    const directLayer = Array.from(menu.children).find((child) => {
      return child &&
        child.matches &&
        child.matches(
          '.navmenu-meganav-wrapper, .navmenu-meganav-standard__wrapper, .navmenu-meganav-standard__items, .navmenu, .navmenu-depth-2, .navmenu-depth-3'
        );
    });

    if (directLayer) {
      directLayer.classList.add('gb-menu-motion-layer');
      return;
    }

    const nestedLayer = menu.querySelector(
      '.navmenu-meganav-wrapper, .navmenu-meganav-standard__wrapper, .navmenu-meganav-standard__items'
    );

    if (nestedLayer) {
      nestedLayer.classList.add('gb-menu-motion-layer');
      return;
    }

    /*
      Basic dropdown fallback:
      If the submenu itself is the list, animate its direct items together.
    */
    Array.from(menu.children).forEach((child) => {
      if (child && child.nodeType === 1 && child.classList) {
        child.classList.add('gb-menu-motion-layer');
      }
    });
  }

  function setSummaryExpanded(summary, expanded) {
    if (!summary) return;

    const value = expanded ? 'true' : 'false';

    if (summary.getAttribute('aria-expanded') !== value) {
      summary.setAttribute('aria-expanded', value);
    }
  }

  function getFirstMenuContentLink(menu) {
    if (!menu) return null;

    return menu.querySelector(
      '.navmenu-link-depth-2, .navmenu-link-depth-3, .navmenu-meganav-standard__item > a, a[href]'
    );
  }

  function getCurrentMenuContentOffset(item) {
    const value = parseFloat(item.style.getPropertyValue('--gb-menu-content-offset-x') || '0');

    return Number.isFinite(value) ? value : 0;
  }

  function getFirstTextRect(element) {
    if (!element) return null;

    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          return node.nodeValue && node.nodeValue.trim()
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const textNode = walker.nextNode();

    if (!textNode) return null;

    const range = document.createRange();
    range.selectNodeContents(textNode);

    const rects = Array.from(range.getClientRects()).filter((rect) => {
      return rect && rect.width > 0 && rect.height > 0;
    });

    range.detach();

    return rects.length ? rects[0] : null;
  }

  function updateMenuContentAlignment(item) {
    if (!item) return;

    if (!shouldAlignMenuUnderTrigger(item)) {
      item.classList.remove('gb-menu-align-under-trigger');
      item.style.removeProperty('--gb-menu-content-offset-x');
      return;
    }

    const summary = getSummary(item);
    const menu = getMenu(item);

    if (!summary || !menu) return;

    const firstContentLink = getFirstMenuContentLink(menu);

    /*
      Align true text edge to true text edge:
      - summaryRect alone includes the nav link's padding and chevron space
      - linkRect alone includes the submenu link/list indentation
      Measuring the first real text node removes those offsets.
    */
    const summaryTextRect = getFirstTextRect(summary) || summary.getBoundingClientRect();
    const firstContentTextRect = getFirstTextRect(firstContentLink) ||
      (firstContentLink ? firstContentLink.getBoundingClientRect() : menu.getBoundingClientRect());

    if (!summaryTextRect || !firstContentTextRect) return;

    const currentOffset = getCurrentMenuContentOffset(item);
    const offsetX = Math.max(
      0,
      Math.round(currentOffset + (summaryTextRect.left - firstContentTextRect.left))
    );

    item.classList.add('gb-menu-align-under-trigger');
    item.style.setProperty('--gb-menu-content-offset-x', `${offsetX}px`);
  }

  function forceDetailsOpen() {
    items.forEach((item) => {
      const details = getDetails(item);
      const summary = getSummary(item);

      if (details) {
        if (!details.open) details.open = true;

        if (details.getAttribute('data-gb-menu-controlled') !== 'true') {
          details.setAttribute('data-gb-menu-controlled', 'true');
        }
      }

      setSummaryExpanded(summary, item === activeItem);
    });
  }

  function clearNativeAnimationState(item) {
    const menu = getMenu(item);
    if (!menu) return;

    if (menu.hasAttribute('data-animation')) {
      menu.removeAttribute('data-animation');
    }

    if (menu.hasAttribute('data-animation-state')) {
      menu.removeAttribute('data-animation-state');
    }

    const animatedChild = menu.querySelector('[data-animation], [data-animation-state]');

    if (!animatedChild) return;

    animatedChild.removeAttribute('data-animation');
    animatedChild.removeAttribute('data-animation-state');

    menu.querySelectorAll('[data-animation], [data-animation-state]').forEach((el) => {
      el.removeAttribute('data-animation');
      el.removeAttribute('data-animation-state');
    });
  }

  function clearMenuHeightCache() {
    menuHeightCache = new WeakMap();
  }

  function getMenuHeight(item) {
    if (!item) return 0;

    const cachedHeight = menuHeightCache.get(item);

    if (typeof cachedHeight === 'number') {
      return cachedHeight;
    }

    const menu = getMenu(item);
    if (!menu) return 0;

    const wrapper = menu.querySelector(
      '.navmenu-meganav-wrapper, .navmenu-meganav-standard__wrapper, .navmenu-meganav-standard__items'
    );

    const menuHeight = Math.ceil(menu.scrollHeight || menu.getBoundingClientRect().height || 0);
    const wrapperHeight = wrapper
      ? Math.ceil(wrapper.scrollHeight || wrapper.getBoundingClientRect().height || 0)
      : 0;
    const height = Math.max(menuHeight, wrapperHeight, 0);

    menuHeightCache.set(item, height);

    return height;
  }

  function clearHeightExpansionState() {
    if (heightExpandTimer) {
      clearTimeout(heightExpandTimer);
      heightExpandTimer = null;
    }

    if (heightRevealTimer) {
      clearTimeout(heightRevealTimer);
      heightRevealTimer = null;
    }

    body.classList.remove('gb-header-menu-height-expanding', 'gb-menu-content-reveal-ready');
    root.style.removeProperty('--gb-menu-content-delay');
    root.style.removeProperty('--gb-menu-content-duration');
  }

  function startHeightAwareReveal(previousHeight, nextHeight, isSwitch) {
    const heightDelta = nextHeight - previousHeight;

    /*
      Only delay content when the new dropdown is meaningfully taller.
      Smaller/similar-height changes stay fast and responsive.
    */
    if (heightDelta < 90) {
      clearHeightExpansionState();
      return;
    }

    const delay = Math.max(45, Math.min(110, Math.round(heightDelta * 0.18)));
    const duration = isSwitch ? SWITCH_FADE_DURATION : 30;

    /*
      Do not remove the height-expanding/reveal classes before the open swipe
      animation has finished. Removing them too early cancels the CSS selector
      and makes the content jump to its final position mid-animation.
    */
    const cleanupDelay = delay + Math.max(duration, OPEN_CLOSE_EXIT_DURATION) + 90;

    clearHeightExpansionState();

    root.style.setProperty('--gb-menu-content-delay', `${delay}ms`);
    root.style.setProperty('--gb-menu-content-duration', `${duration}ms`);

    body.classList.add('gb-header-menu-height-expanding');
    body.classList.remove('gb-menu-content-reveal-ready');

    heightRevealTimer = setTimeout(() => {
      body.classList.add('gb-menu-content-reveal-ready');
      heightRevealTimer = null;
    }, delay);

    heightExpandTimer = setTimeout(() => {
      clearHeightExpansionState();
    }, cleanupDelay);
  }

  function setGlassHeightForItem(item) {
    const height = getMenuHeight(item);

    if (height > 0) {
      root.style.setProperty('--gb-active-menu-height', `${height}px`);
      body.classList.add('gb-header-menu-open');
    }
  }

  function removeItemClasses(item) {
    if (!item) return;

    item.classList.remove('gb-menu-active', 'gb-menu-exiting', 'gb-chevron-active');

    const summary = getSummary(item);
    setSummaryExpanded(summary, false);
  }

  function markActiveItem(item) {
    item.classList.add('gb-menu-active');
    item.classList.remove('gb-menu-exiting');

    const summary = getSummary(item);
    setSummaryExpanded(summary, true);
  }

  function clearChevronSwitchTimer() {
    if (chevronSwitchTimer) {
      clearTimeout(chevronSwitchTimer);
      chevronSwitchTimer = null;
    }
  }

  function clearChevronActiveItems() {
    if (!items.length) return;

    items.forEach((item) => {
      item.classList.remove('gb-chevron-active');
    });
  }

  function setChevronActiveItem(item) {
    clearChevronSwitchTimer();
    clearChevronActiveItems();

    if (item) {
      item.classList.add('gb-chevron-active');
    }
  }

  function scheduleSequentialChevronSwitch(previousItem, nextItem) {
    clearChevronSwitchTimer();

    if (previousItem) {
      previousItem.classList.remove('gb-chevron-active');
    }

    if (nextItem) {
      nextItem.classList.remove('gb-chevron-active');
    }

    chevronSwitchTimer = setTimeout(() => {
      chevronSwitchTimer = null;

      if (!isDesktop() || isScrollClosing || activeItem !== nextItem) return;

      clearChevronActiveItems();

      if (nextItem) {
        nextItem.classList.add('gb-chevron-active');
      }
    }, CHEVRON_SWITCH_DELAY);
  }

  function clearOpenCloseMotionState() {
    if (openMotionTimer) {
      clearTimeout(openMotionTimer);
      openMotionTimer = null;
    }

    if (closeMotionTimer) {
      clearTimeout(closeMotionTimer);
      closeMotionTimer = null;
    }

    if (closeClipFrame) {
      window.cancelAnimationFrame(closeClipFrame);
      closeClipFrame = null;
    }

    body.classList.remove('gb-menu-opening', 'gb-menu-closing');
    root.style.setProperty('--gb-menu-closing-clip-height', '0px');
  }

  function startOpeningState() {
    clearOpenCloseMotionState();

    body.classList.add('gb-menu-opening');
    body.classList.remove('gb-menu-closing');

    /*
      Keep this class long enough for height-aware opens, where content
      is intentionally revealed after the glass height starts expanding.
    */
    openMotionTimer = setTimeout(() => {
      body.classList.remove('gb-menu-opening');
      openMotionTimer = null;
    }, OPEN_CLOSE_EXIT_DURATION + 220);
  }

  function startClosingState(closingHeight) {
    clearOpenCloseMotionState();

    const safeClosingHeight = Math.max(0, Math.ceil(closingHeight || 0));

    /*
      Closing clip:
      Set the clip to the current dropdown height, then animate it to 0px
      on the next frame. This keeps the text content visually contained
      inside the shrinking glass field, even on tall dropdowns.
    */
    root.style.setProperty('--gb-menu-closing-clip-height', `${safeClosingHeight}px`);

    body.classList.add('gb-menu-closing');
    body.classList.remove('gb-menu-opening');

    closeClipFrame = window.requestAnimationFrame(() => {
      closeClipFrame = null;
      root.style.setProperty('--gb-menu-closing-clip-height', '0px');
    });

    closeMotionTimer = setTimeout(() => {
      body.classList.remove('gb-menu-closing');
      root.style.setProperty('--gb-menu-closing-clip-height', '0px');
      closeMotionTimer = null;
    }, OPEN_CLOSE_EXIT_DURATION + 220);
  }

  function clearSwitchingState() {
    if (switchTimer) {
      clearTimeout(switchTimer);
      switchTimer = null;
    }

    if (switchRevealTimer) {
      clearTimeout(switchRevealTimer);
      switchRevealTimer = null;
    }

    body.classList.remove('gb-header-menu-switching', 'gb-menu-switch-reveal-ready');
    root.style.removeProperty('--gb-menu-switch-fade-out-duration');
    root.style.removeProperty('--gb-menu-switch-fade-in-duration');
  }

  function startSwitchingState() {
    clearOpenCloseMotionState();
    clearSwitchingState();

    root.style.setProperty('--gb-menu-switch-fade-out-duration', `${SWITCH_FADE_OUT_DURATION}ms`);
    root.style.setProperty('--gb-menu-switch-fade-in-duration', `${SWITCH_FADE_IN_DURATION}ms`);

    body.classList.add('gb-header-menu-switching');
    body.classList.remove('gb-menu-switch-reveal-ready');

    switchRevealTimer = setTimeout(() => {
      body.classList.add('gb-menu-switch-reveal-ready');
      switchRevealTimer = null;
    }, SWITCH_REVEAL_DELAY);

    switchTimer = setTimeout(() => {
      clearSwitchingState();
    }, SWITCH_EXIT_DURATION);
  }

  function notifyMenuStateChange() {
    document.dispatchEvent(new CustomEvent('gb:menu-state-change'));
  }

  function clearOpenTimer() {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }

    pendingOpenItem = null;
  }

  function scheduleOpenItem(item, delay) {
    if (!isDesktop() || !item || !items.includes(item)) return;

    clearCloseTimer();

    if (activeItem === item) {
      clearOpenTimer();
      setGlassHeightForItem(item);
      return;
    }

    clearOpenTimer();

    pendingOpenItem = item;
    openTimer = setTimeout(() => {
      const itemToOpen = pendingOpenItem;

      openTimer = null;
      pendingOpenItem = null;

      if (!isDesktop() || !itemToOpen || !items.includes(itemToOpen)) return;
      if (isScrollClosing) return;

      /*
        Only open if the pointer is still on the same dropdown trigger
        after the hover-intent delay. Fast passovers are ignored.
      */
      if (getDropdownItemUnderPointer() !== itemToOpen) return;

      openItem(itemToOpen);
    }, delay);
  }

  function scheduleHoverOpenItem(item) {
    const delay = activeItem ? SWITCH_OPEN_DELAY : INITIAL_OPEN_DELAY;
    scheduleOpenItem(item, delay);
  }

  function clearCloseTimer() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function openItem(item) {
    if (!isDesktop() || !item || !items.includes(item)) return;
    if (isScrollClosing) return;

    clearScrollHoverReset();
    clearCloseTimer();
    forceDetailsOpen();
    updateMenuContentAlignment(item);

    const previousItem = activeItem;
    const isSwitch = previousItem && previousItem !== item;
    const previousHeight = previousItem ? getMenuHeight(previousItem) : 0;
    const nextHeight = getMenuHeight(item);

    if (activeItem === item) {
      setChevronActiveItem(item);
      setGlassHeightForItem(item);
      return;
    }

    if (isSwitch) {
      clearOpenCloseMotionState();
      clearHeightExpansionState();
      startSwitchingState();
    } else {
      clearSwitchingState();
      startOpeningState();
      startHeightAwareReveal(previousHeight, nextHeight, false);
    }

    if (isSwitch) {

      previousItem.classList.remove('gb-menu-active');
      previousItem.classList.add('gb-menu-exiting');

      setTimeout(() => {
        previousItem.classList.remove('gb-menu-exiting');
      }, SWITCH_EXIT_DURATION);
    } else if (previousItem) {
      previousItem.classList.remove('gb-menu-active');
      previousItem.classList.add('gb-menu-exiting');

      setTimeout(() => {
        previousItem.classList.remove('gb-menu-exiting');
      }, OPEN_CLOSE_EXIT_DURATION);
    }

    activeItem = item;

    if (isSwitch) {
      scheduleSequentialChevronSwitch(previousItem, item);
    } else {
      setChevronActiveItem(item);
    }

    items.forEach((menuItem) => {
      if (menuItem !== item && menuItem !== previousItem) {
        removeItemClasses(menuItem);
      }

      clearNativeAnimationState(menuItem);
    });

    markActiveItem(item);
    setGlassHeightForItem(item);
    notifyMenuStateChange();
  }

  function closeMenu() {
    clearOpenTimer();
    clearCloseTimer();
    clearHeightExpansionState();

    if (!activeItem) {
      clearSwitchingState();
      clearOpenCloseMotionState();
      clearChevronSwitchTimer();
      clearChevronActiveItems();
      body.classList.remove('gb-header-menu-open');
      root.style.setProperty('--gb-active-menu-height', '0px');
      notifyMenuStateChange();
      return;
    }

    const closingItem = activeItem;
    const closingHeight = getMenuHeight(closingItem);

    clearChevronSwitchTimer();
    closingItem.classList.remove('gb-chevron-active');

    closingItem.classList.remove('gb-menu-active');
    closingItem.classList.add('gb-menu-exiting');

    startClosingState(closingHeight);

    activeItem = null;

    clearSwitchingState();
    body.classList.remove('gb-header-menu-open');
    root.style.setProperty('--gb-active-menu-height', '0px');
    notifyMenuStateChange();

    items.forEach((item) => {
      const summary = getSummary(item);
      setSummaryExpanded(summary, false);
    });

    setTimeout(() => {
      closingItem.classList.remove('gb-menu-exiting');
    }, OPEN_CLOSE_EXIT_DURATION);
  }

  function closeMenuFromScroll() {
    if (!isDesktop() || !activeItem) return;

    isScrollClosing = true;
    startScrollHoverReset();
    closeMenu();

    window.setTimeout(() => {
      isScrollClosing = false;
    }, 95);
  }

  function scheduleCloseMenu() {
    clearCloseTimer();

    closeTimer = setTimeout(() => {
      if (!isPointerInsideVisualMenuSafeZone()) {
        closeMenu();
      }
    }, CLOSE_DELAY);
  }

  function reopenAfterScrollResetIfStillHovering() {
    scrollResetReopenTimer = null;

    if (!isDesktop() || !isScrollHoverResetActive() || isScrollClosing) return;

    const item = getDropdownItemUnderPointer();

    if (!item) return;

    clearScrollHoverReset();
    scheduleOpenItem(item, SWITCH_OPEN_DELAY);
  }

  function scheduleScrollResetReopen() {
    if (scrollResetReopenTimer) return;

    scrollResetReopenTimer = window.setTimeout(reopenAfterScrollResetIfStillHovering, 105);
  }

  function handleScrollHoverResetPointerMovement(event) {
    if (!isScrollHoverResetActive() || !nav) {
      return false;
    }

    const item = getDropdownItemUnderPointer() || getDropdownItemFromTarget(event.target);

    if (!item) {
      if (!isPointerCurrentlyInsideTopNavRow()) {
        clearScrollHoverReset();
      }

      return false;
    }

    /*
      After a scroll-close reset, keep the label/chevron reset while the mouse
      is stationary. But any intentional mouse movement on a dropdown trigger
      should count as a fresh hover. If the scroll-close lock is still active,
      queue one reopen check immediately after it finishes.
    */
    if (isScrollClosing) {
      scheduleScrollResetReopen();
      event.stopImmediatePropagation();
      return true;
    }

    clearScrollHoverReset();
    scheduleOpenItem(item, SWITCH_OPEN_DELAY);
    event.stopImmediatePropagation();

    return true;
  }

  function requestHeightRefresh() {
    if (frame) cancelAnimationFrame(frame);

    frame = requestAnimationFrame(() => {
      frame = null;

      clearMenuHeightCache();

      if (activeItem) {
        forceDetailsOpen();
        prepareMenuMotionLayers(activeItem);
        updateMenuContentAlignment(activeItem);
        setGlassHeightForItem(activeItem);
      }
    });
  }

  function processPointerMoveState() {
    pointerFrame = null;

    /*
      During manual nav untuck, the nav row may animate under the cursor.
      Pointerover can be missed, so pointermove schedules delayed hit checks
      that continue after the cursor stops moving.
    */
    if (isManualUntuckHoverWatchActive()) {
      scheduleOpenDropdownUnderPointer();
    }

    if (!activeItem) return;

    if (isPointerInsideVisualMenuSafeZone()) {
      clearCloseTimer();
    } else {
      scheduleCloseMenu();
    }
  }

  function schedulePointerMoveStateCheck() {
    if (pointerFrame) return;

    pointerFrame = requestAnimationFrame(processPointerMoveState);
  }

  function onPointerMove(event) {
    if (!isDesktop()) return;

    rememberPointerPosition(event);

    if (handleScrollHoverResetPointerMovement(event)) {
      return;
    }

    schedulePointerMoveStateCheck();
  }

  function onPointerOver(event) {
    if (!isDesktop() || !nav) return;

    rememberPointerPosition(event);

    if (isScrollHoverResetActive() && isPointerCurrentlyInsideTopNavRow()) {
      /*
        If the dropdown was closed by scroll while the pointer is still over
        the same nav row, suppress automatic hover reopening. Pointer movement
        is handled separately and can reopen the dropdown as a fresh hover.
      */
      if (pointerCameFromInsideTopNav(event)) {
        event.stopImmediatePropagation();
        return;
      }

      clearScrollHoverReset();
    }

    const item = event.target.closest('.site-navigation .navmenu-depth-1 > li');

    if (!item) return;

    if (items.includes(item)) {
      scheduleHoverOpenItem(item);
      event.stopImmediatePropagation();
      return;
    }

    /*
      Hovering a top-level nav item without a dropdown should close the
      current dropdown instead of keeping it open across the whole nav row.
    */
    clearOpenTimer();

    if (activeItem) {
      closeMenu();
    }
  }

  function onMouseOver(event) {
    if (!isDesktop() || !nav) return;

    const item = event.target.closest('.site-navigation .navmenu-depth-1 > li');

    if (!item || !items.includes(item)) return;

    event.stopImmediatePropagation();
  }

  function onPointerOut(event) {
    if (!isDesktop()) return;

    rememberPointerPosition(event);

    if (isScrollHoverResetActive() && pointerMovedOutsideTopNav(event)) {
      clearScrollHoverReset();
    }

    setTimeout(() => {
      if (!isPointerInsideVisualMenuSafeZone()) {
        clearOpenTimer();
        scheduleCloseMenu();
      }
    }, 20);
  }

  function onFocusIn(event) {
    if (!isDesktop() || !nav) return;

    const item = event.target.closest('.site-navigation .navmenu-depth-1 > li');

    if (!item || !items.includes(item)) return;

    clearOpenTimer();
    openItem(item);
  }

  function onDocumentClick(event) {
    if (!isDesktop()) return;

    /*
      Desktop dropdown top-level labels should still navigate on first click.
      Empire's native <details>/<summary> behavior can otherwise require
      one click to activate/open and a second click to follow the link.
      Submenu clicks are left untouched.
    */
    if (nav && event && event.target) {
      const item = event.target.closest('.site-navigation .navmenu-depth-1 > li');

      if (
        item &&
        items.includes(item) &&
        getDetails(item) &&
        getMenu(item) &&
        !event.target.closest('.navmenu-submenu')
      ) {
        const summary = getSummary(item);

        if (summary && summary.contains(event.target)) {
          const href = getTopLevelHref(item, event.target);

          if (href && href !== '#') {
            event.preventDefault();
            event.stopImmediatePropagation();

            closeMenu();
            navigateToTopLevelHref(href, event);
            return;
          }
        }
      }
    }

    if (activeItem && !isInsideNavMenuArea(event.target)) {
      closeMenu();
    }
  }

  function onKeyDown(event) {
    if (!isDesktop()) return;

    if (event.key === 'Escape') {
      closeMenu();
    }
  }

  function onWheel() {
    closeMenuFromScroll();
  }

  function onScroll() {
    closeMenuFromScroll();
  }

  function enableController() {
    header = getHeader();
    nav = getNav();

    if (!header || !nav) return;

    items = collectItems();

    if (!items.length) return;

    clearMenuHeightCache();

    items.forEach((item) => {
      item.classList.add('gb-menu-has-submenu');
      prepareMenuMotionLayers(item);

      if (shouldAlignMenuUnderTrigger(item)) {
        item.classList.add('gb-menu-align-under-trigger');
      } else {
        item.classList.remove('gb-menu-align-under-trigger');
        item.style.removeProperty('--gb-menu-content-offset-x');
      }
    });

    body.classList.add('gb-custom-desktop-menu');

    forceDetailsOpen();

    document.addEventListener('pointermove', onPointerMove, true);
    document.addEventListener('pointerover', onPointerOver, true);
    document.addEventListener('mouseover', onMouseOver, true);
    document.addEventListener('pointerout', onPointerOut, true);
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('click', onDocumentClick, true);
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('gb:manual-nav-untuck-watch', startManualUntuckHoverWatch);
    window.addEventListener('wheel', onWheel, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', requestHeightRefresh);
  }

  function disableController() {
    closeMenu();

    body.classList.remove('gb-custom-desktop-menu');

    if (items.length) {
      items.forEach((item) => {
        item.classList.remove('gb-menu-has-submenu', 'gb-menu-align-under-trigger');
        item.style.removeProperty('--gb-menu-content-offset-x');
        clearMenuMotionLayers(item);
        removeItemClasses(item);

        const details = getDetails(item);
        const summary = getSummary(item);

        if (details && details.getAttribute('data-gb-menu-controlled') === 'true') {
          details.removeAttribute('data-gb-menu-controlled');
          details.open = false;
        }

        if (summary) summary.removeAttribute('aria-expanded');
      });
    }

    document.removeEventListener('pointermove', onPointerMove, true);
    document.removeEventListener('pointerover', onPointerOver, true);
    document.removeEventListener('mouseover', onMouseOver, true);
    document.removeEventListener('pointerout', onPointerOut, true);
    document.removeEventListener('focusin', onFocusIn, true);
    document.removeEventListener('click', onDocumentClick, true);
    document.removeEventListener('keydown', onKeyDown, true);
    document.removeEventListener('gb:manual-nav-untuck-watch', startManualUntuckHoverWatch);
    window.removeEventListener('wheel', onWheel);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', requestHeightRefresh);

    clearOpenTimer();
    clearUnderPointerTimers();
    clearHeightExpansionState();
    clearSwitchingState();
    clearOpenCloseMotionState();
    clearChevronSwitchTimer();
    clearChevronActiveItems();

    if (pointerFrame) {
      cancelAnimationFrame(pointerFrame);
      pointerFrame = null;
    }

    manualUntuckHoverWatchUntil = 0;
    clearScrollHoverReset();
    clearMenuHeightCache();

    nav = null;
    header = null;
    items = [];
    activeItem = null;
    lastPointerX = null;
    lastPointerY = null;
  }

  function syncController() {
    if (isDesktop()) {
      if (!body.classList.contains('gb-custom-desktop-menu')) {
        enableController();
      } else {
        requestHeightRefresh();
      }
    } else if (body.classList.contains('gb-custom-desktop-menu')) {
      disableController();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncController);
  } else {
    syncController();
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', syncController);
  } else {
    desktopQuery.addListener(syncController);
  }
})();





































/* ============================================================
   Gymbuild – Empire Native Nav Margin Hook
   Custom-code-only source hook
   Catches Empire's own [data-site-navigation] margin-top changes
   before they render, without editing empire.js.

   Uses separate gb-empire-hook-* classes so the existing native
   detector cannot clear/override this hook's protection state.
   ============================================================ */
(function () {
  const body = document.body;
  if (!body || body.classList.contains('gb-empire-hook-ready')) return;

  body.classList.add('gb-empire-hook-ready');

  const nativeSetAttribute = Element.prototype.setAttribute;

  const TUCK_HOOK_LOCK_DURATION = 300;
  const UNTUCK_HOOK_PREP_DURATION = 90;
  const UNTUCK_HOOK_LOCK_DURATION = 260;

  let clearTimer = null;
  let revealTimer = null;

  function isEmpireSiteNavigation(element) {
    return Boolean(
      element &&
      element.matches &&
      element.matches('[data-site-navigation]') &&
      element.closest('[data-site-header]')
    );
  }

  function clearRevealTimer() {
    if (revealTimer) {
      window.clearTimeout(revealTimer);
      revealTimer = null;
    }
  }

  function clearHookClassesSoon(duration) {
    if (clearTimer) window.clearTimeout(clearTimer);

    clearTimer = window.setTimeout(() => {
      body.classList.remove(
        'gb-empire-hook-nav-tucking',
        'gb-empire-hook-nav-untuck-prep',
        'gb-empire-hook-nav-untucking'
      );

      clearTimer = null;
    }, duration);
  }

  function startHookTuckProtection() {
    clearRevealTimer();

    body.classList.add('gb-empire-hook-nav-tucking');
    body.classList.remove(
      'gb-empire-hook-nav-untuck-prep',
      'gb-empire-hook-nav-untucking'
    );

    clearHookClassesSoon(TUCK_HOOK_LOCK_DURATION);
  }

  function startHookUntuckProtection() {
    clearRevealTimer();

    body.classList.add('gb-empire-hook-nav-untuck-prep');
    body.classList.remove(
      'gb-empire-hook-nav-tucking',
      'gb-empire-hook-nav-untucking'
    );

    revealTimer = window.setTimeout(() => {
      body.classList.remove('gb-empire-hook-nav-untuck-prep');
      body.classList.add('gb-empire-hook-nav-untucking');

      revealTimer = null;
    }, UNTUCK_HOOK_PREP_DURATION);

    clearHookClassesSoon(UNTUCK_HOOK_LOCK_DURATION);
  }

  Element.prototype.setAttribute = function (name, value) {
    if (
      name === 'style' &&
      typeof value === 'string' &&
      isEmpireSiteNavigation(this) &&
      value.indexOf('margin-top') !== -1
    ) {
      const normalizedValue = value.replace(/\s+/g, '').toLowerCase();

      if (normalizedValue.indexOf('margin-top:-') !== -1) {
        startHookTuckProtection();
      } else if (normalizedValue.indexOf('margin-top:0') !== -1) {
        startHookUntuckProtection();
      }
    }

    return nativeSetAttribute.apply(this, arguments);
  };
})();





































/* ============================================================
   Gymbuild – Native Empire Tuck / Untuck State Detector
   Desktop only
   Watches Empire's real inline nav margin-top tuck
   Pre-locks the nav text on scroll intent and manual nav-toggle clicks
   Adds body classes while the native tuck OR untuck is happening
   Does not modify Empire's margin-top value during normal scroll behavior

   Update:
   - Adds untuck prep state to keep native text hidden while Empire moves
     through the overlap zone
   - Keeps tuck hidden long enough to avoid native end flicker
   - Resets manual-open state when Empire returns to near-top/default state
   ============================================================ */
(function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const body = document.body;
  const root = document.documentElement;

  if (!body || !root) return;

  const TUCK_VISUAL_LOCK_DURATION = 270;
  const UNTUCK_PREP_DURATION = 70;
  const UNTUCK_VISUAL_LOCK_DURATION = 250;
  const TOP_SCROLL_TOLERANCE = 2;
  const MANUAL_TOGGLE_DEDUPE_MS = 90;

  let header = null;
  let nav = null;
  let observer = null;
  let clearTimer = null;
  let revealTimer = null;
  let lastMarginTop = 0;
  let lastScrollY = window.scrollY || 0;
  let lastManualToggleAt = 0;
  let isManualNavExpanded = false;
  let isPinningManualNav = false;

  function isDesktop() {
    return desktopQuery.matches;
  }

  function getHeader() {
    return document.querySelector('[data-site-header]');
  }

  function getNav() {
    return document.querySelector('[data-site-navigation]');
  }

  function getCurrentMarginTop() {
    if (!nav) return 0;

    const marginTop = parseFloat(nav.style.marginTop || '0');
    return Number.isFinite(marginTop) ? marginTop : 0;
  }

  function hasStickyScrolledState() {
    if (!header) return false;

    if (header.classList.contains('site-header-sticky--scrolled')) return true;
    if (body.classList.contains('site-header-sticky--scrolled')) return true;
    if (root.classList.contains('site-header-sticky--scrolled')) return true;

    let parent = header.parentElement;

    while (parent && parent !== body && parent !== root) {
      if (parent.classList && parent.classList.contains('site-header-sticky--scrolled')) {
        return true;
      }

      parent = parent.parentElement;
    }

    return false;
  }

  function isHeaderNavOpen() {
    return Boolean(header && header.classList.contains('site-header-nav--open'));
  }

  function isNativeDefaultOpenZone() {
    const currentMarginTop = getCurrentMarginTop();

    /*
      Empire restores the header before absolute top.
      When sticky-scrolled is gone and the nav margin is back to 0,
      treat it as the default/open reset zone.
    */
    return currentMarginTop >= -1 && !hasStickyScrolledState();
  }

  function isNavActuallyTuckedOrTucking() {
    const currentMarginTop = getCurrentMarginTop();

    if (currentMarginTop < -1) return true;
    if (hasStickyScrolledState()) return true;

    if (
      header &&
      !header.classList.contains('site-header-nav--open') &&
      window.scrollY > TOP_SCROLL_TOLERANCE
    ) {
      return true;
    }

    return false;
  }

  function isNavCurrentlyOpen() {
    const currentMarginTop = getCurrentMarginTop();

    if (header && header.classList.contains('site-header-nav--open')) return true;
    if (currentMarginTop >= -1 && !isNavActuallyTuckedOrTucking()) return true;

    return false;
  }

  function isManualNavPinnedOpen() {
    return Boolean(isManualNavExpanded && isHeaderNavOpen());
  }

  function clearRevealTimer() {
    if (revealTimer) {
      clearTimeout(revealTimer);
      revealTimer = null;
    }
  }

  function clearNativeMotionClassesSoon(duration) {
    if (clearTimer) clearTimeout(clearTimer);

    clearTimer = setTimeout(() => {
      body.classList.remove(
        'gb-native-nav-tucking',
        'gb-native-nav-untuck-prep',
        'gb-native-nav-untucking'
      );

      clearTimer = null;
    }, duration);
  }

  function clearAllNativeMotionClasses() {
    if (clearTimer) {
      clearTimeout(clearTimer);
      clearTimer = null;
    }

    clearRevealTimer();

    body.classList.remove(
      'gb-native-nav-tucking',
      'gb-native-nav-untuck-prep',
      'gb-native-nav-untucking'
    );
  }

  function resetManualNavStateInDefaultZone() {
    /*
      Once Empire has returned the header/nav to its near-top default state,
      release our manual-open pin so the next downward scroll can tuck naturally.
    */
    if (isNativeDefaultOpenZone()) {
      isManualNavExpanded = false;
      isPinningManualNav = false;
      lastMarginTop = 0;

      clearAllNativeMotionClasses();

      return true;
    }

    return false;
  }

  function pinManualNavOpen() {
    if (!isDesktop() || !nav || !header || !isManualNavPinnedOpen()) return;

    if (resetManualNavStateInDefaultZone()) return;

    const currentMarginTop = getCurrentMarginTop();

    if (currentMarginTop < -1 || nav.style.marginTop) {
      isPinningManualNav = true;

      nav.style.marginTop = '0px';
      header.classList.add('site-header-nav--open');

      isPinningManualNav = false;
      lastMarginTop = 0;
    }
  }

  function clearNativeMotionClassesNowIfIdleAtDefault() {
    resetManualNavStateInDefaultZone();
  }

  function startTuckingLock(options = {}) {
    if (!isDesktop() || body.classList.contains('gb-header-menu-open')) return;

    if (!options.force && !isNavCurrentlyOpen()) return;

    clearRevealTimer();

    body.classList.add('gb-native-nav-tucking');
    body.classList.remove('gb-native-nav-untuck-prep', 'gb-native-nav-untucking');

    clearNativeMotionClassesSoon(TUCK_VISUAL_LOCK_DURATION);
  }

  function startUntuckingLock(options = {}) {
    if (!isDesktop() || body.classList.contains('gb-header-menu-open')) return;

    if (!options.force && !isNavActuallyTuckedOrTucking()) return;

    clearRevealTimer();

    body.classList.add('gb-native-nav-untuck-prep');
    body.classList.remove('gb-native-nav-tucking', 'gb-native-nav-untucking');

    revealTimer = setTimeout(() => {
      body.classList.remove('gb-native-nav-untuck-prep');
      body.classList.add('gb-native-nav-untucking');

      revealTimer = null;
    }, UNTUCK_PREP_DURATION);

    clearNativeMotionClassesSoon(UNTUCK_VISUAL_LOCK_DURATION);
  }

  function isNativeNavToggle(target) {
    if (!target) return false;

    return Boolean(
      target.closest(
        [
          '[data-site-header-nav-toggle]',
          '[data-site-header-menu-toggle]',
          '[data-menu-toggle]',
          '[data-header-menu-toggle]',
          '.site-header-menu-toggle',
          '.site-header-nav-toggle',
          '.site-header-mobile-menu-toggle',
          '.site-header-main-menu-toggle',
          'button[aria-controls="site-header-nav"]',
          'button[aria-controls*="site-header-nav"]',
          'button[aria-label*="menu" i]',
          'button[aria-label*="navigation" i]'
        ].join(',')
      )
    );
  }

  function onManualNavToggle(event) {
    if (!isDesktop() || !event || !isNativeNavToggle(event.target)) return;

    const now = performance.now ? performance.now() : Date.now();

    if (now - lastManualToggleAt < MANUAL_TOGGLE_DEDUPE_MS) {
      return;
    }

    lastManualToggleAt = now;

    if (isNavCurrentlyOpen()) {
      isManualNavExpanded = false;
      startTuckingLock({ force: true });
    } else {
      isManualNavExpanded = true;
      startUntuckingLock({ force: true });

      requestAnimationFrame(() => {
        pinManualNavOpen();

        /*
          Tell the custom desktop menu controller to watch the pointer while
          the nav is untucking. This catches a stationary hover after the nav
          finishes animating into place.
        */
        document.dispatchEvent(new CustomEvent('gb:manual-nav-untuck-watch'));
      });
    }
  }

  function syncTuckState() {
    if (!isDesktop() || !nav) return;

    if (isPinningManualNav) return;

    if (resetManualNavStateInDefaultZone()) return;

    if (isManualNavPinnedOpen()) {
      pinManualNavOpen();
      return;
    }

    const currentMarginTop = getCurrentMarginTop();

    const isClosing = currentMarginTop < -1;
    const isOpening = lastMarginTop < -1 && currentMarginTop >= -1;

    if (isClosing) {
      isManualNavExpanded = false;
      startTuckingLock({ force: true });
    } else if (isOpening) {
      startUntuckingLock({ force: true });
    } else {
      clearNativeMotionClassesNowIfIdleAtDefault();
    }

    lastMarginTop = currentMarginTop;
  }

  function onScrollIntent() {
    if (!isDesktop()) return;

    const currentScrollY = window.scrollY || 0;

    if (resetManualNavStateInDefaultZone()) {
      lastScrollY = currentScrollY;
      return;
    }

    if (isManualNavPinnedOpen()) {
      pinManualNavOpen();
      lastScrollY = currentScrollY;
      return;
    }

    if (currentScrollY > lastScrollY) {
      startTuckingLock();
    } else if (currentScrollY < lastScrollY) {
      startUntuckingLock();
    } else {
      clearNativeMotionClassesNowIfIdleAtDefault();
    }

    lastScrollY = currentScrollY;
  }

  function onWheel(event) {
    if (!isDesktop() || !event) return;

    if (resetManualNavStateInDefaultZone()) return;

    if (isManualNavPinnedOpen()) {
      pinManualNavOpen();
      return;
    }

    if (event.deltaY > 0) {
      startTuckingLock();
    } else if (event.deltaY < 0) {
      startUntuckingLock();
    }
  }

  function attach() {
    header = getHeader();
    nav = getNav();

    if (!nav || observer) return;

    lastMarginTop = getCurrentMarginTop();
    lastScrollY = window.scrollY || 0;

    observer = new MutationObserver(syncTuckState);

    observer.observe(nav, {
      attributes: true,
      attributeFilter: ['style']
    });

    window.addEventListener('scroll', onScrollIntent, { passive: true });
    window.addEventListener('wheel', onWheel, { passive: true });
    window.addEventListener('touchmove', onScrollIntent, { passive: true });

    document.addEventListener('pointerdown', onManualNavToggle, true);
    document.addEventListener('click', onManualNavToggle, true);

    syncTuckState();
  }

  function init() {
    attach();

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', attach);
    } else {
      desktopQuery.addListener(attach);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();





















/* ============================================================
   Gymbuild – Universal Variant Image Batch Filter V7
   Safer Swiper rebuild version for Empire product galleries.
   V7 keeps the V6 thumbnail-click fix and improves the labeling system.

   Recommended product image alt text format:
   - Variant-specific image: Variant Value
   - Variant-specific image with optional internal order note: Variant Value | 1
   - Shared/common image: leave alt text blank

   Still supported for older products:
   Product Name | Tactical Black | 1
   Product Name | Tactical Black | 2
   Product Name | Patriot Blue | 1
   Product Name | Recon Desert | 1
   Product Name | Common | 1

   Behavior:
   - Rebuilds the main gallery and thumbnail gallery using:
     selected variant images + blank/untagged common images + optional Common images.
   - Only activates on products where at least one image alt text matches the
     selected variant value. Products without variant-labeled media restore all media.
   - Supports color, finish, frame color, collar type, and other variant option
     groups when the option values are found in media alt text.
   - Common/shared images no longer need a Common alt label. Blank or untagged
     media stays visible for every variant and keeps its original media order.
   - Updates the visible option label safely by replacing the full label.
   - Does not edit swatch colors or swatch styling.
   ============================================================ */
(function () {
  const READY_CLASS = 'gb-variant-media-filter-ready';
  const ACTIVE_CLASS = 'gb-variant-media-filter-active';

  const PRODUCT_SCOPE_SELECTOR = '.product--outer, [data-product-wrapper], .product__container';
  const GALLERY_SELECTOR = 'product-gallery.product-gallery, product-gallery';
  const VIEWER_SELECTOR = '[data-swiper-viewer]';
  const NAVIGATION_SELECTOR = '[data-swiper-navigation]';
  const VARIANT_SELECTION_SELECTOR = 'variant-selection[data-variant-selection], [data-variant-selection]';
  const VARIANT_SELECT_SELECTOR = '[data-variants][name="id"], [data-variants]';

  const COMMON_TOKEN = 'common';

  /*
    Preferred option names when multiple option groups could match media labels.
    The filter can still work with other option names if their values are found
    in the image alt text.
  */
  const PREFERRED_OPTION_KEYWORDS = [
    'color',
    'colour',
    'finish',
    'frame color',
    'frame colour',
    'collar',
    'collar type'
  ];

  const galleryState = new WeakMap();
  const updateTimers = new WeakMap();

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[|_/\\.,;:()[\]{}'"’‘“”!?+-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function containsPhrase(text, phrase) {
    const normalizedText = ` ${normalize(text)} `;
    const normalizedPhrase = normalize(phrase);

    return Boolean(normalizedPhrase && normalizedText.includes(` ${normalizedPhrase} `));
  }

  function optionNameLooksPreferred(value) {
    const text = normalize(value);

    return PREFERRED_OPTION_KEYWORDS.some((keyword) => {
      const key = normalize(keyword);
      return text === key || text.includes(key);
    });
  }

  function cleanOptionText(value) {
    return String(value || '')
      .replace(/\s+-\s+[$€£¥]?\s*[\d,.]+.*$/i, '')
      .split(' / ')[0]
      .replace(/\s+/g, ' ')
      .trim();
  }

  function dedupe(values) {
    const seen = new Set();

    return values
      .map(cleanOptionText)
      .filter((value) => {
        const key = normalize(value);
        if (!key || key === 'not selected' || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function getProductScope(gallery) {
    return gallery.closest(PRODUCT_SCOPE_SELECTOR) || document;
  }

  function getVariantSelection(scope) {
    return scope.querySelector(VARIANT_SELECTION_SELECTOR);
  }

  function getVariantSelect(scope) {
    return scope.querySelector(VARIANT_SELECT_SELECTOR);
  }

  function getViewer(gallery) {
    return gallery.querySelector(VIEWER_SELECTOR);
  }

  function getNavigation(gallery) {
    return gallery.querySelector(NAVIGATION_SELECTOR);
  }

  function getWrapper(container) {
    return container ? container.querySelector(':scope > .swiper-wrapper') : null;
  }

  function getDirectSlides(container) {
    const wrapper = getWrapper(container);
    return wrapper ? Array.from(wrapper.children).filter((child) => child.classList && child.classList.contains('swiper-slide')) : [];
  }

  function captureGalleryState(gallery) {
    if (galleryState.has(gallery)) return galleryState.get(gallery);

    const viewer = getViewer(gallery);
    const navigation = getNavigation(gallery);
    const viewerWrapper = getWrapper(viewer);
    const navigationWrapper = getWrapper(navigation);

    const state = {
      viewer,
      navigation,
      viewerWrapper,
      navigationWrapper,
      viewerSlides: getDirectSlides(viewer),
      thumbnailSlides: getDirectSlides(navigation),
      currentKey: ''
    };

    galleryState.set(gallery, state);
    return state;
  }

  function appendSlides(wrapper, slides) {
    if (!wrapper) return;

    const fragment = document.createDocumentFragment();

    slides.forEach((slide) => {
      if (slide) {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('data-gb-variant-media-hidden');
        slide.classList.remove('gb-variant-media-hidden');
        slide.style.removeProperty('display');
        fragment.appendChild(slide);
      }
    });

    while (wrapper.firstChild) {
      wrapper.removeChild(wrapper.firstChild);
    }

    wrapper.appendChild(fragment);
  }

  function updateSwiper(container, slideToStart) {
    if (!container || !container.swiper) return;

    try {
      container.swiper.update();
      container.swiper.updateSlides();
      container.swiper.updateProgress();
      container.swiper.updateSlidesClasses();

      if (slideToStart && typeof container.swiper.slideTo === 'function') {
        container.swiper.slideTo(0, 0, false);
        container.swiper.updateSlidesClasses();
      }
    } catch (error) {
      /* Empire may initialize Swiper after our first pass. Later timers retry. */
    }
  }

  function setActiveThumbnail(navigation, activeIndex) {
    const slides = getDirectSlides(navigation);

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;

      slide.classList.toggle('swiper-slide-thumb-active', isActive);
      slide.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function activateThumbnail(gallery, thumbnailSlide, animate) {
    if (!gallery || !thumbnailSlide) return;

    const state = captureGalleryState(gallery);
    const navigation = state.navigation || getNavigation(gallery);
    const viewer = state.viewer || getViewer(gallery);

    if (!navigation || !viewer || !navigation.contains(thumbnailSlide)) return;

    const visibleThumbnails = getDirectSlides(navigation);
    const targetIndex = visibleThumbnails.indexOf(thumbnailSlide);

    if (targetIndex < 0) return;

    try {
      if (viewer.swiper && typeof viewer.swiper.slideTo === 'function') {
        viewer.swiper.slideTo(targetIndex, animate ? 250 : 0, false);
        viewer.swiper.updateSlidesClasses();
      }

      if (navigation.swiper && typeof navigation.swiper.slideTo === 'function') {
        navigation.swiper.slideTo(targetIndex, animate ? 250 : 0, false);
        navigation.swiper.updateSlidesClasses();
      }

      setActiveThumbnail(navigation, targetIndex);
    } catch (error) {
      /* Keep native Empire behavior as a fallback if Swiper is not ready. */
    }
  }

  function handleThumbnailClick(gallery, event) {
    if (!gallery || !event || !event.target) return;

    if (event.target.closest('[data-swiper-prev], [data-swiper-next], .product-gallery__scroll-button')) {
      return;
    }

    const thumbnailSlide = event.target.closest('[data-swiper-thumbnail], [data-swiper-navigation] .swiper-slide');

    if (!thumbnailSlide || !gallery.contains(thumbnailSlide)) return;

    const navigation = getNavigation(gallery);
    if (!navigation || !navigation.contains(thumbnailSlide)) return;

    event.preventDefault();
    event.stopPropagation();

    activateThumbnail(gallery, thumbnailSlide, true);
  }

  function handleThumbnailKeydown(gallery, event) {
    if (!event || (event.key !== 'Enter' && event.key !== ' ')) return;

    const thumbnailSlide = event.target && event.target.closest
      ? event.target.closest('[data-swiper-thumbnail], [data-swiper-navigation] .swiper-slide')
      : null;

    if (!thumbnailSlide || !gallery.contains(thumbnailSlide)) return;

    event.preventDefault();
    activateThumbnail(gallery, thumbnailSlide, true);
  }

  function restoreGallery(gallery) {
    const state = captureGalleryState(gallery);

    appendSlides(state.viewerWrapper, state.viewerSlides);
    appendSlides(state.navigationWrapper, state.thumbnailSlides);

    gallery.classList.remove(ACTIVE_CLASS);
    state.currentKey = 'all';

    updateSwiper(state.viewer, true);
    updateSwiper(state.navigation, true);
  }

  function getSlideAlt(slide) {
    if (!slide) return '';

    const image = slide.querySelector('img[alt]');
    const imageAlt = image ? image.getAttribute('alt') : '';

    if (imageAlt) return imageAlt;

    return slide.getAttribute('data-alt') || slide.getAttribute('aria-label') || '';
  }

  function getStateAltTexts(state) {
    return state.viewerSlides.map((slide) => getSlideAlt(slide));
  }

  function getOptionGroups(scope) {
    return Array.from(scope.querySelectorAll('[data-options-selection] fieldset'));
  }

  function getInputsForGroup(group) {
    if (!group) return [];

    return Array.from(group.querySelectorAll('input[type="radio"], input[type="checkbox"]'))
      .filter((input) => input && !input.disabled);
  }

  function getOptionNameFromGroup(group) {
    if (!group) return '';

    const input = group.querySelector('input[name^="options["], select[name^="options["]');

    if (input && input.name) {
      const match = input.name.match(/^options\[(.+)\]$/);
      if (match && match[1]) return match[1].trim();
    }

    const label = group.querySelector('.options-selection__option-name');

    if (label) {
      const attrName =
        label.getAttribute('data-variant-option-name') ||
        label.getAttribute('data-variant-option-choose-name') ||
        '';

      if (attrName) {
        return String(attrName).replace(/:.*$/, '').replace(/\s+/g, ' ').trim();
      }

      const labelText = (label.textContent || '').replace(/\s+/g, ' ').trim();
      const labelName = labelText.split(':')[0].trim();

      if (labelName) return labelName;
    }

    return '';
  }

  function getSelectionFromGroup(group) {
    const inputs = getInputsForGroup(group);
    const checkedInput = inputs.find((input) => input.checked);
    const optionName = getOptionNameFromGroup(group);

    return {
      group,
      optionName,
      selectedValue: checkedInput ? cleanOptionText(checkedInput.value) : '',
      optionValues: dedupe(inputs.map((input) => input.value)),
      isPreferred: optionNameLooksPreferred(optionName)
    };
  }

  function getSelectionFromVariantSelect(scope, altTexts) {
    const select = getVariantSelect(scope);

    if (!select || !select.options) {
      return {
        group: null,
        optionName: '',
        selectedValue: '',
        optionValues: [],
        isPreferred: false
      };
    }

    const selectedOption = select.options[select.selectedIndex];
    const optionValues = dedupe(
      Array.from(select.options)
        .filter((option) => option && option.value && option.value !== 'not-selected')
        .map((option) => option.textContent || option.value || '')
    );

    const selectedValue = selectedOption
      ? cleanOptionText(selectedOption.textContent || selectedOption.value)
      : '';

    return {
      group: null,
      optionName: '',
      selectedValue,
      optionValues,
      isPreferred: false,
      score: scoreOptionValuesInAltTexts(optionValues, altTexts).score
    };
  }

  function scoreOptionValuesInAltTexts(optionValues, altTexts) {
    const matchedValues = new Set();
    let score = 0;

    optionValues.forEach((value) => {
      if (!value) return;

      const matched = altTexts.some((altText) => {
        if (!normalize(altText)) return false;
        if (containsPhrase(altText, COMMON_TOKEN)) return false;
        return containsPhrase(altText, value);
      });

      if (matched) {
        matchedValues.add(normalize(value));
        score += 1;
      }
    });

    return {
      score,
      matchedValues
    };
  }

  function getBestOptionSelection(scope, state) {
    const altTexts = getStateAltTexts(state);
    const groups = getOptionGroups(scope);

    const groupSelections = groups
      .map(getSelectionFromGroup)
      .filter((selection) => selection.selectedValue && selection.optionValues.length)
      .map((selection) => {
        const scored = scoreOptionValuesInAltTexts(selection.optionValues, altTexts);

        return {
          ...selection,
          score: scored.score,
          matchedValues: scored.matchedValues
        };
      })
      .filter((selection) => selection.score > 0)
      .sort((a, b) => {
        if (a.isPreferred !== b.isPreferred) return a.isPreferred ? -1 : 1;
        if (a.score !== b.score) return b.score - a.score;
        return 0;
      });

    if (groupSelections.length) return groupSelections[0];

    const selectSelection = getSelectionFromVariantSelect(scope, altTexts);

    if (selectSelection.selectedValue && selectSelection.optionValues.length && selectSelection.score > 0) {
      return selectSelection;
    }

    return {
      group: null,
      optionName: '',
      selectedValue: '',
      optionValues: [],
      isPreferred: false,
      score: 0
    };
  }

  function updateOptionLabel(selection) {
    if (!selection || !selection.group || !selection.selectedValue) return;

    const label = selection.group.querySelector('.options-selection__option-name');
    if (!label) return;

    const optionName = selection.optionName || 'Option';
    label.textContent = `${optionName}: ${selection.selectedValue}`;

    const valuesWrapper = selection.group.querySelector('[data-variant-option]');
    if (valuesWrapper) {
      valuesWrapper.setAttribute('data-variant-option-chosen-value', selection.selectedValue);
    }
  }

  function classifyAlt(altText, selectedValue, optionValues) {
    const normalizedAlt = normalize(altText);

    /*
      Blank image alt text is treated as a shared/common product image.
      This lets common media stay visible for every variant without requiring
      the merchant to label it "Common".
    */
    if (!normalizedAlt) return 'common';

    if (containsPhrase(altText, COMMON_TOKEN)) return 'common';
    if (selectedValue && containsPhrase(altText, selectedValue)) return 'selected';

    const hasOtherValue = optionValues.some((value) => {
      if (!value || normalize(value) === normalize(selectedValue)) return false;
      return containsPhrase(altText, value);
    });

    /*
      If the image alt text does not mention any known variant value, keep it
      visible for every variant. This preserves normal product/media images,
      lifestyle images, and any existing unlabeled images as common media.
    */
    return hasOtherValue ? 'other' : 'common';
  }

  function getVisibleIndexes(state, selectedValue, optionValues) {
    const classifications = state.viewerSlides.map((slide) => classifyAlt(getSlideAlt(slide), selectedValue, optionValues));
    const hasSelected = classifications.some((type) => type === 'selected');
    const hasVariantTagged = classifications.some((type) => type === 'selected' || type === 'other');

    if (!hasSelected || !hasVariantTagged) return [];

    return classifications
      .map((type, index) => ({ type, index }))
      .filter((item) => item.type === 'selected' || item.type === 'common')
      .map((item) => item.index);
  }

  function filterPhotoswipeThumbnails(selectedValue, optionValues) {
    const pswp = document.querySelector('[data-photoswipe], #pswp');
    if (!pswp) return;

    const thumbs = Array.from(pswp.querySelectorAll('[data-photoswipe-thumb-scroller] img, [data-photoswipe-thumb-scroller] button, [data-photoswipe-thumb-scroller] a'));

    thumbs.forEach((thumb) => {
      const alt = thumb.getAttribute('alt') || thumb.getAttribute('aria-label') || '';
      const type = classifyAlt(alt, selectedValue, optionValues);
      const shouldShow = type === 'selected' || type === 'common';
      const target = thumb.closest('button, a, .swiper-slide, div') || thumb;

      target.style.display = shouldShow ? '' : 'none';
      target.setAttribute('data-gb-photoswipe-filtered', shouldShow ? 'false' : 'true');
    });
  }

  function applyFilter(gallery) {
    if (!gallery || !document.documentElement.contains(gallery)) return;

    const scope = getProductScope(gallery);
    const variantSelection = getVariantSelection(scope);
    const variantSelect = getVariantSelect(scope);

    if (!variantSelection && !variantSelect) {
      restoreGallery(gallery);
      return;
    }

    const state = captureGalleryState(gallery);

    if (!state.viewerWrapper || !state.viewerSlides.length) {
      restoreGallery(gallery);
      return;
    }

    const selection = getBestOptionSelection(scope, state);
    const selectedValue = selection.selectedValue;
    const optionValues = selection.optionValues;

    if (!selectedValue || !optionValues.length) {
      restoreGallery(gallery);
      return;
    }

    updateOptionLabel(selection);

    const visibleIndexes = getVisibleIndexes(state, selectedValue, optionValues);

    if (!visibleIndexes.length) {
      restoreGallery(gallery);
      return;
    }

    const key = `${normalize(selectedValue)}::${visibleIndexes.join(',')}`;
    const visibleViewerSlides = visibleIndexes.map((index) => state.viewerSlides[index]).filter(Boolean);
    const visibleThumbnailSlides = visibleIndexes.map((index) => state.thumbnailSlides[index]).filter(Boolean);

    const didRebuild = state.currentKey !== key;

    if (didRebuild) {
      appendSlides(state.viewerWrapper, visibleViewerSlides);

      if (state.navigationWrapper && visibleThumbnailSlides.length) {
        appendSlides(state.navigationWrapper, visibleThumbnailSlides);
      }

      state.currentKey = key;
    }

    gallery.classList.add(ACTIVE_CLASS);

    /*
      Only jump back to the first image when the selected variant media group changes.
      Do not reset the main image on every delayed retry, because that makes
      thumbnail clicks appear unresponsive.
    */
    updateSwiper(state.viewer, didRebuild);
    updateSwiper(state.navigation, didRebuild);
    filterPhotoswipeThumbnails(selectedValue, optionValues);
  }

  function scheduleUpdate(gallery) {
    if (!gallery) return;

    const existingTimers = updateTimers.get(gallery) || [];
    existingTimers.forEach((timer) => window.clearTimeout(timer));

    const timers = [0, 80, 220, 500, 900, 1400].map((delay) => {
      return window.setTimeout(() => applyFilter(gallery), delay);
    });

    updateTimers.set(gallery, timers);
  }

  function initGallery(gallery) {
    if (!gallery || gallery.classList.contains(READY_CLASS)) return;

    const scope = getProductScope(gallery);
    const variantSelection = getVariantSelection(scope);
    const variantSelect = getVariantSelect(scope);

    if (!variantSelection && !variantSelect) return;

    gallery.classList.add(READY_CLASS);
    captureGalleryState(gallery);

    gallery.addEventListener('click', (event) => handleThumbnailClick(gallery, event), true);
    gallery.addEventListener('keydown', (event) => handleThumbnailKeydown(gallery, event), true);

    if (variantSelect) {
      variantSelect.addEventListener('change', () => scheduleUpdate(gallery));
      variantSelect.addEventListener('input', () => scheduleUpdate(gallery));
    }

    if (variantSelection) {
      const observer = new MutationObserver(() => scheduleUpdate(gallery));

      observer.observe(variantSelection, {
        attributes: true,
        attributeFilter: ['variant']
      });
    }

    scope.addEventListener('change', (event) => {
      if (event.target && event.target.closest && event.target.closest('[data-options-selection], [data-variants]')) {
        scheduleUpdate(gallery);
      }
    }, true);

    scope.addEventListener('click', (event) => {
      if (event.target && event.target.closest && event.target.closest('[data-options-selection], [data-variants]')) {
        scheduleUpdate(gallery);
      }
    }, true);

    document.addEventListener('click', (event) => {
      if (event.target && event.target.closest && event.target.closest('.media__lightbox-button, [data-photoswipe-trigger-for]')) {
        scheduleUpdate(gallery);
      }
    }, true);

    scheduleUpdate(gallery);
  }

  function initAllGalleries() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGalleries);
  } else {
    initAllGalleries();
  }

  document.addEventListener('shopify:section:load', initAllGalleries);
  document.addEventListener('shopify:section:select', initAllGalleries);
})();




































/* ============================================================
   Gymbuild – Contact form submit scroll
   Forces success and error states to land at the same contact form position
   Used on /pages/contact
   ============================================================ */

(function () {
  function initGymbuildContactScroll() {
    var contactPage = document.querySelector('.site-page[data-template-contact]');
    if (!contactPage) return;

    var statusBox = document.getElementById('gb-contact-status');
    if (!statusBox) return;

    var contactHeading = document.getElementById('gb-contact-form');
    if (!contactHeading) return;

    var params = new URLSearchParams(window.location.search);
    var isContactSuccess = params.get('contact_posted') === 'true';
    var isContactError = params.get('form_type') === 'contact' && !isContactSuccess;
    var hasContactStatus = statusBox.classList.contains('gb-contact-status--success') ||
      statusBox.classList.contains('gb-contact-status--error');

    if (!isContactSuccess && !isContactError && !hasContactStatus) return;

    function scrollToContactForm() {
      var offset = window.matchMedia('(max-width: 749px)').matches ? 130 : 190;
      var targetY = contactHeading.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetY,
        behavior: 'smooth'
      });
    }

    if (window.location.hash !== '#gb-contact-form') {
      window.history.replaceState(
        null,
        '',
        window.location.pathname + window.location.search + '#gb-contact-form'
      );
    }

    setTimeout(scrollToContactForm, 80);
    setTimeout(scrollToContactForm, 250);
    setTimeout(scrollToContactForm, 650);
    setTimeout(scrollToContactForm, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGymbuildContactScroll);
  } else {
    initGymbuildContactScroll();
  }

  window.addEventListener('load', initGymbuildContactScroll);
  window.addEventListener('pageshow', initGymbuildContactScroll);
})();












































/* ============================================================
   Gymbuild – Vendor link to brand collection rewrite
   Redirects Shopify default vendor links to clean collection pages
   using the exact current Shopify vendor names.

   Example:
   /collections/vendors?q=Body-Solid
   becomes:
   /collections/body-solid

   This avoids editing the main product Liquid code.
   ============================================================ */

(function () {
  /* ==========================================================
     Main Gymbuild brands
     ========================================================== */

  const mainBrandCollectionMap = {
    'Body-Solid': '/collections/body-solid',
    'XMARK': '/collections/xmark',
    'Muscle D Fitness': '/collections/muscle-d-fitness',
    'Major Fitness': '/collections/major-fitness',
    'Fringe Sport': '/collections/fringe-sport'
  };

  /* ==========================================================
     Body-Solid sub-brands
     ========================================================== */

  const bodySolidSubbrandCollectionMap = {
    'Powerline by Body-Solid': '/collections/powerline-by-body-solid',
    'Endurance by Body-Solid': '/collections/endurance-by-body-solid',
    'Body-Solid Pro ClubLine': '/collections/body-solid-pro-clubline',
    'Body-Solid Tools': '/collections/body-solid-tools'
  };

  /* ==========================================================
     Combined vendor-to-collection map
     ========================================================== */

  const vendorCollectionMap = {
    ...mainBrandCollectionMap,
    ...bodySolidSubbrandCollectionMap
  };

  function rewriteVendorLinks() {
    const vendorLinks = document.querySelectorAll(
      'a[href*="/collections/vendors?q="]'
    );

    vendorLinks.forEach(function (link) {
      let vendorName = '';

      try {
        const url = new URL(link.href, window.location.origin);
        vendorName = url.searchParams.get('q') || '';
      } catch (error) {
        return;
      }

      const collectionUrl = vendorCollectionMap[vendorName];

      if (!collectionUrl) return;

      link.setAttribute('href', collectionUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteVendorLinks);
  } else {
    rewriteVendorLinks();
  }

  document.addEventListener('shopify:section:load', rewriteVendorLinks);
})();














































/* ============================================================
   Gymbuild – Cart Shipping Message Override
   Replaces Empire's default "Taxes and shipping calculated..."
   cart message without editing the cart Liquid file.
   ============================================================ */

(function () {
  const GB_CART_SHIPPING_MESSAGE =
    "Free shipping to the 48 contiguous United States and Washington, DC.";

  function updateGymbuildCartShippingMessage() {
    const cartMessage = document.querySelector(
      ".cart-shipping .cart-message.meta"
    );

    if (!cartMessage) return;

    cartMessage.textContent = GB_CART_SHIPPING_MESSAGE;
    cartMessage.setAttribute("data-gb-cart-shipping-message", "custom");
  }

  document.addEventListener("DOMContentLoaded", updateGymbuildCartShippingMessage);

  document.addEventListener("shopify:section:load", updateGymbuildCartShippingMessage);

  document.addEventListener("cart:updated", updateGymbuildCartShippingMessage);

  setTimeout(updateGymbuildCartShippingMessage, 300);
})();











































/* ============================================================
   Gymbuild – PDP Purchase Assurance + Smart Delivery Details
   - Preserves current trust badges
   - Reads exact shipping_type values:
     Parcel / Freight / Parcel_Freight
   - Resolves base product shipping type in this order:
       selected variant shipping_type → product shipping_type fallback
   - Selected purchase-option add-ons participate in the final shipping state
   - Parcel + Freight combinations resolve to Parcel_Freight
   - Body-Solid family:
       Parcel          = estimated ship date +1–3 business days
       Freight         = estimated ship date +3–5 business days
       Parcel_Freight  = estimated ship date +1–5 business days
   - Major Fitness:
       Parcel          = estimated ship date +2–4 business days
       Freight         = estimated ship date +2–4 business days
       Parcel_Freight  = estimated ship date +2–4 business days
   - Supported-brand estimated ship date is promoted into card header
   - Other brands:
       Shipping-type-specific Delivery Details only
   - Suppresses estimated ship date when unavailable
   - Uses Body-Solid / Central Time for Body-Solid date logic
   - Uses the shopper's local calendar date for Major Fitness date logic
   - Skips weekends + major U.S. fulfillment holidays
   - Keeps standardized Shipping & Delivery accordion rows aligned
   ============================================================ */

(function () {
  const PURCHASE_SELECTOR =
    '.product-block--form .product-form--atc';

  const ATC_BUTTON_SELECTOR =
    '.product-form--atc-button[data-product-atc]';

  const TRUST_SELECTOR =
    '.gb-pdp-trust';

  const DATA_SELECTOR =
    '#gb-product-delivery-data';

  const BODY_SOLID_TIME_ZONE =
    'America/Chicago';

  const MAJOR_FITNESS_VENDOR =
    'Major Fitness';


  /* ==========================================================
     Body-Solid family vendors
     ========================================================== */

  const BODY_SOLID_VENDORS = new Set([
    'Body-Solid',
    'Powerline by Body-Solid',
    'Endurance by Body-Solid',
    'Body-Solid Pro ClubLine',
    'Body-Solid Tools'
  ]);


  /* ==========================================================
     Exact Gymbuild shipping_type values
     ========================================================== */

  const VALID_SHIPPING_TYPES = new Set([
    'Parcel',
    'Freight',
    'Parcel_Freight'
  ]);


  /* ==========================================================
     Body-Solid estimated ship windows
     ========================================================== */

  const BODY_SOLID_SHIP_WINDOWS = {
    Parcel: {
      min: 1,
      max: 3
    },

    Freight: {
      min: 3,
      max: 5
    },

    Parcel_Freight: {
      min: 1,
      max: 5
    }
  };


  /* ==========================================================
     Major Fitness estimated ship windows

     Gymbuild conservative dealer / Impact estimate:
     in-stock products use +2–4 business days for Parcel,
     Freight, and Parcel_Freight. This is a ship / dispatch
     estimate, not a delivery / transit estimate.
     ========================================================== */

  const MAJOR_FITNESS_SHIP_WINDOWS = {
    Parcel: {
      min: 2,
      max: 4
    },

    Freight: {
      min: 2,
      max: 4
    },

    Parcel_Freight: {
      min: 2,
      max: 4
    }
  };


  /* ==========================================================
     Delivery row icons
     ========================================================== */

  const DELIVERY_ICONS = {

    clock: `
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M12 7.5v5l3.25 2"></path>
    `,

    parcel: `
      <path d="M4 7.25 12 3l8 4.25v9.5L12 21l-8-4.25z"></path>
      <path d="M4 7.25 12 12l8-4.75"></path>
      <path d="M12 12v9"></path>
    `,

    envelope: `
      <path d="M4 5.5h16v12H4z"></path>
      <path d="m4 7 8 6 8-6"></path>
    `,

    truck: `
      <path d="M3.5 6.5h11v9h-11z"></path>
      <path d="M14.5 9h3.2l2.8 3v3.5h-6z"></path>
      <circle cx="7" cy="17" r="1.75"></circle>
      <circle cx="17.5" cy="17" r="1.75"></circle>
    `,

    coordination: `
      <rect x="4" y="5.5" width="16" height="14" rx="2"></rect>
      <path d="M8 3.5v4"></path>
      <path d="M16 3.5v4"></path>
      <path d="M4 9.5h16"></path>
    `,

    info: `
      <circle cx="12" cy="12" r="8.5"></circle>
      <path d="M12 10.5v5"></path>
      <path d="M12 7.5h.01"></path>
    `,

    wrench: `
      <path d="M15.15 6.05a.95.95 0 0 0 0 1.34l1.45 1.45a.95.95 0 0 0 1.34 0l1.55-1.55a4.45 4.45 0 0 1-5.8 5.8l-6.15 6.15a1.8 1.8 0 1 1-2.55-2.55l6.15-6.15a4.45 4.45 0 0 1 5.8-5.8l-1.59 1.31Z"></path>
    `
  };


  /* ==========================================================
     Product availability
     ========================================================== */

  function isCurrentSelectionAvailable() {
    const button =
      document.querySelector(
        ATC_BUTTON_SELECTOR
      );

    if (!button) {
      return true;
    }

    const buttonText =
      (button.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    if (button.disabled) {
      return false;
    }

    if (
      button.getAttribute(
        'aria-disabled'
      ) === 'true'
    ) {
      return false;
    }

    if (
      buttonText.includes('sold out') ||
      buttonText.includes('unavailable')
    ) {
      return false;
    }

    return true;
  }


  /* ==========================================================
     Product + variant delivery data
     ========================================================== */

  const watchedVariantSelections =
    new WeakSet();


  function normalizeShippingType(
    value
  ) {
    const shippingType =
      String(value || '').trim();

    return VALID_SHIPPING_TYPES.has(
      shippingType
    )
      ? shippingType
      : '';
  }


  function getVariantSelectionElement() {
    return document.querySelector(
      '.product-block--form variant-selection[data-variant-selection], ' +
      '.product-main variant-selection[data-variant-selection], ' +
      'variant-selection[data-variant-selection]'
    );
  }


  function getSelectedVariantId(
    dataElement
  ) {
    const variantSelection =
      getVariantSelectionElement();

    if (variantSelection) {
      const attributeVariantId =
        (
          variantSelection.getAttribute(
            'variant'
          ) ||
          ''
        ).trim();

      if (attributeVariantId) {
        return attributeVariantId;
      }

      const variantInput =
        variantSelection.querySelector(
          '[data-variants][name="id"], [name="id"]'
        );

      if (
        variantInput &&
        variantInput.value
      ) {
        return String(
          variantInput.value
        ).trim();
      }
    }


    const fallbackInput =
      document.querySelector(
        '.product-block--form [data-variants][name="id"], ' +
        '.product-block--form [name="id"]'
      );

    if (
      fallbackInput &&
      fallbackInput.value
    ) {
      return String(
        fallbackInput.value
      ).trim();
    }


    if (dataElement) {
      return (
        dataElement.dataset.initialVariantId ||
        ''
      ).trim();
    }

    return '';
  }


  function getVariantDeliveryData(
    dataElement,
    selectedVariantId
  ) {
    if (
      !dataElement ||
      !selectedVariantId
    ) {
      return null;
    }

    const jsonElement =
      dataElement.querySelector(
        '[data-gb-variant-delivery-data]'
      );

    if (!jsonElement) {
      return null;
    }

    let variants = [];

    try {
      variants =
        JSON.parse(
          jsonElement.textContent ||
          '[]'
        );
    } catch (error) {
      return null;
    }

    if (!Array.isArray(variants)) {
      return null;
    }

    const matchedVariant =
      variants.find(
        function (variant) {
          return (
            variant &&
            String(variant.id) ===
              String(selectedVariantId)
          );
        }
      );

    if (!matchedVariant) {
      return null;
    }

    return {
      id: String(
        matchedVariant.id
      ),

      shippingType:
        normalizeShippingType(
          matchedVariant.shippingType
        ),

      available:
        matchedVariant.available !==
        false
    };
  }


  function watchVariantSelection() {
    document
      .querySelectorAll(
        'variant-selection[data-variant-selection]'
      )
      .forEach(
        function (variantSelection) {
          if (
            watchedVariantSelections.has(
              variantSelection
            )
          ) {
            return;
          }

          watchedVariantSelections.add(
            variantSelection
          );

          const observer =
            new MutationObserver(
              function (mutations) {
                const variantChanged =
                  mutations.some(
                    function (mutation) {
                      return (
                        mutation.type ===
                          'attributes' &&
                        mutation.attributeName ===
                          'variant'
                      );
                    }
                  );

                if (!variantChanged) {
                  return;
                }

                window.setTimeout(
                  refreshDeliverySystem,
                  0
                );
              }
            );

          observer.observe(
            variantSelection,
            {
              attributes: true,
              attributeFilter: [
                'variant'
              ]
            }
          );
        }
      );
  }


  function getSelectedPurchaseOptionDeliveryData() {
    return Array
      .from(
        document.querySelectorAll(
          '.product-block--form [data-gb-po-item]'
        )
      )
      .map(
        function (item) {
          const quantityInput =
            item.querySelector(
              '[data-gb-po-qty-input]'
            );

          const quantity =
            Number.parseInt(
              quantityInput
                ? quantityInput.value
                : '0',
              10
            );

          if (
            !Number.isFinite(quantity) ||
            quantity <= 0
          ) {
            return null;
          }

          const shippingType =
            normalizeShippingType(
              item.dataset.resolvedShippingType ||
              item.dataset.variantShippingType ||
              item.dataset.productShippingType
            );

          return {
            vendor:
              (
                item.dataset.vendor ||
                ''
              ).trim(),

            shippingType:
              shippingType
          };
        }
      )
      .filter(Boolean);
  }


  function resolveSetupShippingType(
    baseShippingType,
    selectedAddOns
  ) {
    const normalizedBaseShippingType =
      normalizeShippingType(
        baseShippingType
      );

    if (!normalizedBaseShippingType) {
      return '';
    }

    const shippingTypes = [
      normalizedBaseShippingType
    ];

    let hasUnknownSelectedAddOn =
      false;

    selectedAddOns.forEach(
      function (addOn) {
        const addOnShippingType =
          normalizeShippingType(
            addOn.shippingType
          );

        if (!addOnShippingType) {
          hasUnknownSelectedAddOn =
            true;

          return;
        }

        shippingTypes.push(
          addOnShippingType
        );
      }
    );

    if (
      hasUnknownSelectedAddOn ||
      shippingTypes.includes(
        'Parcel_Freight'
      )
    ) {
      return 'Parcel_Freight';
    }

    const uniqueTypes =
      new Set(
        shippingTypes
      );

    if (
      uniqueTypes.has('Parcel') &&
      uniqueTypes.has('Freight')
    ) {
      return 'Parcel_Freight';
    }

    if (
      uniqueTypes.has('Freight')
    ) {
      return 'Freight';
    }

    return 'Parcel';
  }


  function isConfirmedMixedShipping(
    baseShippingType,
    selectedAddOns
  ) {
    const shippingTypes = [
      normalizeShippingType(
        baseShippingType
      )
    ];

    selectedAddOns.forEach(
      function (addOn) {
        shippingTypes.push(
          normalizeShippingType(
            addOn.shippingType
          )
        );
      }
    );

    if (
      shippingTypes.some(
        function (shippingType) {
          return (
            shippingType !== 'Parcel' &&
            shippingType !== 'Freight'
          );
        }
      )
    ) {
      return false;
    }

    return (
      shippingTypes.includes('Parcel') &&
      shippingTypes.includes('Freight')
    );
  }


  function selectedSetupSupportsBodySolidEstimate(
    baseVendor,
    selectedAddOns
  ) {
    if (
      !BODY_SOLID_VENDORS.has(
        baseVendor
      )
    ) {
      return false;
    }

    return selectedAddOns.every(
      function (addOn) {
        return BODY_SOLID_VENDORS.has(
          addOn.vendor
        );
      }
    );
  }


  function selectedSetupSupportsMajorFitnessEstimate(
    baseVendor,
    selectedAddOns
  ) {
    if (
      baseVendor !==
      MAJOR_FITNESS_VENDOR
    ) {
      return false;
    }

    return selectedAddOns.every(
      function (addOn) {
        return (
          addOn.vendor ===
          MAJOR_FITNESS_VENDOR
        );
      }
    );
  }


  function getProductDeliveryData() {
    const dataElement =
      document.querySelector(
        DATA_SELECTOR
      );

    let vendor = '';
    let productShippingType = '';
    let productAvailable = true;

    if (dataElement) {
      vendor =
        (
          dataElement.dataset.vendor ||
          ''
        ).trim();

      productShippingType =
        normalizeShippingType(
          dataElement.dataset.shippingType
        );

      if (
        dataElement.dataset.available ===
        'false'
      ) {
        productAvailable = false;
      }
    }

    const selectedVariantId =
      getSelectedVariantId(
        dataElement
      );

    const variantData =
      getVariantDeliveryData(
        dataElement,
        selectedVariantId
      );

    const variantShippingType =
      variantData
        ? variantData.shippingType
        : '';

    const baseShippingType =
      variantShippingType ||
      productShippingType;

    const selectedAddOns =
      getSelectedPurchaseOptionDeliveryData();

    const shippingType =
      resolveSetupShippingType(
        baseShippingType,
        selectedAddOns
      );

    const confirmedMixedShipping =
      shippingType ===
        'Parcel_Freight' &&
      isConfirmedMixedShipping(
        baseShippingType,
        selectedAddOns
      );

    const variantAvailable =
      variantData
        ? variantData.available
        : true;

    const isBodySolid =
      BODY_SOLID_VENDORS.has(
        vendor
      );

    const isMajorFitness =
      vendor ===
      MAJOR_FITNESS_VENDOR;

    return {
      vendor: vendor,

      productShippingType:
        productShippingType,

      variantShippingType:
        variantShippingType,

      baseShippingType:
        baseShippingType,

      shippingType:
        shippingType,

      confirmedMixedShipping:
        confirmedMixedShipping,

      selectedVariantId:
        selectedVariantId,

      selectedAddOns:
        selectedAddOns,

      available:
        productAvailable &&
        variantAvailable &&
        isCurrentSelectionAvailable(),

      isBodySolid:
        isBodySolid,

      isMajorFitness:
        isMajorFitness,

      estimatedShipDateSupported:
        selectedSetupSupportsBodySolidEstimate(
          vendor,
          selectedAddOns
        ) ||
        selectedSetupSupportsMajorFitnessEstimate(
          vendor,
          selectedAddOns
        )
    };
  }


  /* ==========================================================
     Business-day date helpers
     ========================================================== */

  function createUTCDate(
    year,
    monthIndex,
    day
  ) {
    return new Date(
      Date.UTC(
        year,
        monthIndex,
        day,
        12,
        0,
        0
      )
    );
  }


  function dateKey(date) {
    const year =
      date.getUTCFullYear();

    const month =
      String(
        date.getUTCMonth() + 1
      ).padStart(2, '0');

    const day =
      String(
        date.getUTCDate()
      ).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }


  function observedFixedHoliday(
    year,
    monthIndex,
    day
  ) {
    const date =
      createUTCDate(
        year,
        monthIndex,
        day
      );

    const weekday =
      date.getUTCDay();

    /*
      Saturday holiday:
      observed Friday
    */
    if (weekday === 6) {
      date.setUTCDate(
        date.getUTCDate() - 1
      );
    }

    /*
      Sunday holiday:
      observed Monday
    */
    if (weekday === 0) {
      date.setUTCDate(
        date.getUTCDate() + 1
      );
    }

    return date;
  }


  function nthWeekdayOfMonth(
    year,
    monthIndex,
    weekday,
    occurrence
  ) {
    const first =
      createUTCDate(
        year,
        monthIndex,
        1
      );

    const offset =
      (
        7 +
        weekday -
        first.getUTCDay()
      ) % 7;

    return createUTCDate(
      year,
      monthIndex,
      1 +
        offset +
        (
          (occurrence - 1) * 7
        )
    );
  }


  function lastWeekdayOfMonth(
    year,
    monthIndex,
    weekday
  ) {
    const last =
      createUTCDate(
        year,
        monthIndex + 1,
        0
      );

    const offset =
      (
        7 +
        last.getUTCDay() -
        weekday
      ) % 7;

    return createUTCDate(
      year,
      monthIndex,
      last.getUTCDate() - offset
    );
  }


  const holidayCache =
    new Map();


  function getMajorFulfillmentHolidays(
    year
  ) {
    if (
      holidayCache.has(year)
    ) {
      return holidayCache.get(year);
    }

    const holidays =
      new Set([

        /*
          New Year's Day
        */
        dateKey(
          observedFixedHoliday(
            year,
            0,
            1
          )
        ),

        /*
          Memorial Day
          Last Monday in May
        */
        dateKey(
          lastWeekdayOfMonth(
            year,
            4,
            1
          )
        ),

        /*
          Independence Day
        */
        dateKey(
          observedFixedHoliday(
            year,
            6,
            4
          )
        ),

        /*
          Labor Day
          First Monday in September
        */
        dateKey(
          nthWeekdayOfMonth(
            year,
            8,
            1,
            1
          )
        ),

        /*
          Thanksgiving
          Fourth Thursday in November
        */
        dateKey(
          nthWeekdayOfMonth(
            year,
            10,
            4,
            4
          )
        ),

        /*
          Christmas Day
        */
        dateKey(
          observedFixedHoliday(
            year,
            11,
            25
          )
        )
      ]);

    holidayCache.set(
      year,
      holidays
    );

    return holidays;
  }


  function isMajorFulfillmentHoliday(
    date
  ) {
    const year =
      date.getUTCFullYear();

    const key =
      dateKey(date);

    /*
      Adjacent years are checked because
      an observed New Year's holiday can
      occur on Dec. 31.
    */
    for (
      let checkYear = year - 1;
      checkYear <= year + 1;
      checkYear += 1
    ) {
      if (
        getMajorFulfillmentHolidays(
          checkYear
        ).has(key)
      ) {
        return true;
      }
    }

    return false;
  }


  function isBusinessDay(date) {
    const weekday =
      date.getUTCDay();

    if (
      weekday === 0 ||
      weekday === 6
    ) {
      return false;
    }

    if (
      isMajorFulfillmentHoliday(
        date
      )
    ) {
      return false;
    }

    return true;
  }


  /* ==========================================================
     Body-Solid warehouse-local date
     ========================================================== */

  function getTodayInBodySolidTimeZone() {
    const formatter =
      new Intl.DateTimeFormat(
        'en-US',
        {
          timeZone:
            BODY_SOLID_TIME_ZONE,

          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }
      );

    const parts =
      formatter.formatToParts(
        new Date()
      );

    const values = {};

    parts.forEach(
      function (part) {
        if (
          part.type !== 'literal'
        ) {
          values[
            part.type
          ] = part.value;
        }
      }
    );

    return createUTCDate(
      Number(values.year),
      Number(values.month) - 1,
      Number(values.day)
    );
  }


  /* ==========================================================
     Major Fitness shopper-local calendar date

     A dealer / Impact fulfillment warehouse timezone has not
     been confirmed, so do not invent one. The estimate uses the
     shopper's local calendar date as the calculation baseline.
     ========================================================== */

  function getTodayInShopperTimeZone() {
    const now =
      new Date();

    return createUTCDate(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
  }


  function addBusinessDays(
    startDate,
    amount
  ) {
    const date =
      new Date(
        startDate.getTime()
      );

    let added = 0;

    while (
      added < amount
    ) {
      date.setUTCDate(
        date.getUTCDate() + 1
      );

      if (
        isBusinessDay(date)
      ) {
        added += 1;
      }
    }

    return date;
  }


  /* ==========================================================
     Date formatting
     ========================================================== */

  function formatShipDate(date) {
    return new Intl.DateTimeFormat(
      'en-US',
      {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric'
      }
    ).format(date);
  }


  function formatShipDateWithYear(
    date
  ) {
    return new Intl.DateTimeFormat(
      'en-US',
      {
        timeZone: 'UTC',
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }
    ).format(date);
  }


  function formatDateRange(
    startDate,
    endDate
  ) {
    const sameYear =
      startDate.getUTCFullYear() ===
      endDate.getUTCFullYear();

    if (sameYear) {
      return (
        `${formatShipDate(startDate)} – ` +
        `${formatShipDate(endDate)}`
      );
    }

    return (
      `${formatShipDateWithYear(startDate)} – ` +
      `${formatShipDateWithYear(endDate)}`
    );
  }


  /* ==========================================================
     Estimated supported-brand ship date
     ========================================================== */

  function getEstimatedShipRange(
    data
  ) {
    if (
      !data.estimatedShipDateSupported
    ) {
      return '';
    }

    if (
      !data.available
    ) {
      return '';
    }

    let shipWindow = null;
    let today = null;

    if (
      data.isBodySolid
    ) {
      shipWindow =
        BODY_SOLID_SHIP_WINDOWS[
          data.shippingType
        ];

      today =
        getTodayInBodySolidTimeZone();
    } else if (
      data.isMajorFitness
    ) {
      shipWindow =
        MAJOR_FITNESS_SHIP_WINDOWS[
          data.shippingType
        ];

      today =
        getTodayInShopperTimeZone();
    }

    if (
      !shipWindow ||
      !today
    ) {
      return '';
    }

    const earliest =
      addBusinessDays(
        today,
        shipWindow.min
      );

    const latest =
      addBusinessDays(
        today,
        shipWindow.max
      );

    return formatDateRange(
      earliest,
      latest
    );
  }


  /* ==========================================================
     Delivery row rendering
     ========================================================== */

  function renderDeliveryRow(
    icon,
    label,
    value
  ) {
    return `
      <div class="gb-pdp-delivery__item">

        <span
          class="gb-pdp-delivery__item-icon"
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            focusable="false"
          >
            ${DELIVERY_ICONS[icon]}
          </svg>
        </span>

        <div class="gb-pdp-delivery__item-content">

          <strong>
            ${label}
          </strong>

          <span>
            ${value}
          </span>

        </div>

      </div>
    `;
  }


  /* ==========================================================
     Shipping-type-specific Delivery Details rows

     Estimated ship date is intentionally NOT rendered here.
     For supported estimate brands it appears prominently in the card header.
     ========================================================== */

  function buildDeliveryRows(data) {
    const rows = [];


    /* --------------------------------------------------------
       Parcel
       -------------------------------------------------------- */

    if (
      data.shippingType ===
      'Parcel'
    ) {
      rows.push(
        renderDeliveryRow(
          'parcel',
          'Shipping method',
          'Parcel via FedEx/UPS.'
        )
      );

      rows.push(
        renderDeliveryRow(
          'wrench',
          'Final setup',
          'You finish positioning and assembly once it arrives.'
        )
      );

      return rows.join('');
    }


    /* --------------------------------------------------------
       Freight
       -------------------------------------------------------- */

    if (
      data.shippingType ===
      'Freight'
    ) {
      rows.push(
        renderDeliveryRow(
          'truck',
          'Shipping method',
          'LTL freight + curbside delivery.'
        )
      );

      rows.push(
        renderDeliveryRow(
          'coordination',
          'Delivery coordination',
          "We'll contact you to schedule a delivery window."
        )
      );

      rows.push(
        renderDeliveryRow(
          'wrench',
          'Final setup',
          'You finish positioning and assembly once it arrives.'
        )
      );

      return rows.join('');
    }


    /* --------------------------------------------------------
      Parcel / Freight
      Exact metafield value:
      Parcel_Freight
      -------------------------------------------------------- */

    if (
      data.shippingType ===
      'Parcel_Freight'
    ) {
      const confirmedMixedShipping =
        data.confirmedMixedShipping ===
        true;

      rows.push(
        renderDeliveryRow(
          'truck',
          'Shipping method',
          confirmedMixedShipping
            ? 'Parcel / LTL freight + curbside delivery.'
            : 'Parcel / LTL freight based on the selected configuration.'
        )
      );

      rows.push(
        renderDeliveryRow(
          'coordination',
          'Delivery coordination',
          confirmedMixedShipping
            ? "We'll contact you to schedule a delivery window."
            : "If freight applies, we'll contact you to coordinate delivery."
        )
      );

      rows.push(
        renderDeliveryRow(
          'wrench',
          'Final setup',
          'You finish positioning and assembly once it arrives.'
        )
      );

      return rows.join('');
    }


    /* --------------------------------------------------------
      Safe fallback if shipping_type is missing
      -------------------------------------------------------- */

    rows.push(
      renderDeliveryRow(
        'info',
        'Shipping details',
        'See Shipping & Delivery below for product-specific information.'
      )
    );

    rows.push(
      renderDeliveryRow(
        'envelope',
        'Order updates',
        'Tracking details are emailed when your order ships.'
      )
    );

    return rows.join('');
  }


  /* ==========================================================
     Purchase Assurance + Delivery Details card
     ========================================================== */

  function createTrustBlock() {
    const data =
      getProductDeliveryData();

    const estimatedShipRange =
      getEstimatedShipRange(
        data
      );

    const wrapper =
      document.createElement(
        'div'
      );

    wrapper.className =
      'gb-pdp-trust';

    wrapper.setAttribute(
      'data-gb-shipping-type',
      data.shippingType ||
        'Unknown'
    );


    /* --------------------------------------------------------
       Card header

       Supported brand with supported estimate:
       Estimated ship date + prominent date

       Other products:
       Delivery Details
       -------------------------------------------------------- */

    const deliveryHeader =
      estimatedShipRange
        ? `
          <div class="gb-pdp-delivery__ship-header">

            <div class="gb-pdp-delivery__ship-heading">

              <div class="gb-pdp-delivery__ship-label">
                Estimated ship date
              </div>

              <div class="gb-pdp-delivery__ship-date">
                ${estimatedShipRange}
              </div>

            </div>

            <div class="gb-pdp-delivery__free">

              <svg
                viewBox="0 0 16 16"
                aria-hidden="true"
                focusable="false"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="6"
                ></circle>

                <path
                  d="m5.3 8 1.7 1.7 3.7-3.7"
                ></path>
              </svg>

              <span>
                Free Shipping
              </span>

            </div>

          </div>
        `
        : `
          <div class="gb-pdp-delivery__header">

            <div class="gb-pdp-delivery__heading">
              Delivery Details
            </div>

            <div class="gb-pdp-delivery__free">

              <svg
                viewBox="0 0 16 16"
                aria-hidden="true"
                focusable="false"
              >
                <circle
                  cx="8"
                  cy="8"
                  r="6"
                ></circle>

                <path
                  d="m5.3 8 1.7 1.7 3.7-3.7"
                ></path>
              </svg>

              <span>
                Free Shipping
              </span>

            </div>

          </div>
        `;


    wrapper.innerHTML = `

      <div class="gb-pdp-delivery">

        ${deliveryHeader}

        <div
          class="gb-pdp-delivery__divider"
          aria-hidden="true"
        ></div>

        <div class="gb-pdp-delivery__list">
          ${buildDeliveryRows(data)}
        </div>

      </div>


      <div
        class="gb-pdp-why"
        aria-label="Why buy from Gymbuild"
      >

        <div class="gb-pdp-why__row">

          <span
            class="gb-pdp-why__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path d="M8.4 14.6A5.2 5.2 0 1 1 15.6 14.6c-.8.7-1.2 1.4-1.3 2.2H9.7c-.1-.8-.5-1.5-1.3-2.2Z"></path>
              <path d="M9.5 19h5"></path>
              <path d="M10.5 21h3"></path>
            </svg>
          </span>

          <div class="gb-pdp-why__content">
            <strong>
              Know Before You Order
            </strong>

            <span>
              We put extra care into the details below, so you know what to expect before you buy.
            </span>
          </div>

        </div>


        <div class="gb-pdp-why__row">

          <span
            class="gb-pdp-why__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path d="M12 3.25 19 6v5.3c0 4.5-2.8 7.7-7 9.45-4.2-1.75-7-4.95-7-9.45V6l7-2.75Z"></path>
              <path d="m8.8 11.8 2.05 2.05 4.4-4.4"></path>
            </svg>
          </span>

          <div class="gb-pdp-why__content">
            <strong>
              We're Here After Delivery
            </strong>

            <span>
              From order updates and delivery questions to warranty support, we're here after the sale, too.
            </span>
          </div>

        </div>

        <div class="gb-pdp-why__row">

          <span
            class="gb-pdp-why__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path d="M4 12a8 8 0 0 1 16 0"></path>
              <path d="M4 12v4.5A1.5 1.5 0 0 0 5.5 18H7v-6H4z"></path>
              <path d="M20 12v4.5A1.5 1.5 0 0 1 18.5 18H17v-6h3z"></path>
              <path d="M17 18c0 1.1-.9 2-2 2h-2"></path>
            </svg>
          </span>

          <div class="gb-pdp-why__content">
            <strong>
              Talk to a Real Person
            </strong>

            <span>
              Questions about your setup?
              <a href="tel:+18444253710">Call +1 (844) 425-3710</a>&nbsp;·&nbsp;<button
                type="button"
                class="gb-pdp-why__link-button"
                data-gb-open-chat
              >Chat with us</button>&nbsp;·&nbsp;<a href="mailto:support@gymbuild.net">Email us</a>
              — we'll help you get it right.
            </span>
          </div>

        </div>


      </div>
      <div
        class="gb-pdp-trust__badges"
        aria-label="Gymbuild purchase assurances"
      >


        <!-- Authorized Dealer -->

        <div class="gb-pdp-trust__badge">

          <span
            class="gb-pdp-trust__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path
                d="M12 3.25 19 6v5.3c0 4.5-2.8 7.7-7 9.45-4.2-1.75-7-4.95-7-9.45V6l7-2.75Z"
              ></path>

              <path
                d="m8.8 11.8 2.05 2.05 4.4-4.4"
              ></path>
            </svg>
          </span>

          <span class="gb-pdp-trust__label">
            Authorized Dealer
          </span>

        </div>


        <!-- Best Price Guarantee -->

        <div class="gb-pdp-trust__badge">

          <span
            class="gb-pdp-trust__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <circle
                cx="12"
                cy="12"
                r="8"
              ></circle>

              <path
                d="M14.35 9.25c-.55-.6-1.35-.95-2.35-.95-1.35 0-2.3.65-2.3 1.65 0 2.45 4.6 1.2 4.6 3.65 0 1.05-.95 1.75-2.35 1.75-1.05 0-1.95-.35-2.6-1"
                transform="translate(12 12) scale(.82) translate(-12 -12)"
              ></path>

              <path
                d="M12 6.9v1.4M12 15.35v1.75"
                transform="translate(12 12) scale(.82) translate(-12 -12)"
              ></path>
            </svg>
          </span>

          <span class="gb-pdp-trust__label">
            Best Price Guarantee
          </span>

        </div>


        <!-- Free Shipping -->

        <div class="gb-pdp-trust__badge">

          <span
            class="gb-pdp-trust__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path
                d="M3.5 6.5h11v9h-11z"
              ></path>

              <path
                d="M14.5 9h3.2l2.8 3v3.5h-6z"
              ></path>

              <circle
                cx="7"
                cy="17"
                r="1.75"
              ></circle>

              <circle
                cx="17.5"
                cy="17"
                r="1.75"
              ></circle>
            </svg>
          </span>

          <span class="gb-pdp-trust__label">
            Free Shipping
          </span>

        </div>


        <!-- Manufacturer Warranty -->

        <div class="gb-pdp-trust__badge">

          <span
            class="gb-pdp-trust__icon"
            aria-hidden="true"
          >
            <svg
              viewBox="0 0 24 24"
              focusable="false"
            >
              <path
                d="M12 3.25 19 6v5.3c0 4.5-2.8 7.7-7 9.45-4.2-1.75-7-4.95-7-9.45V6l7-2.75Z"
              ></path>

              <circle
                cx="12"
                cy="10.5"
                r="3.2"
              ></circle>

              <path
                d="M12 8.7v2.1l1.45.9"
              ></path>
            </svg>
          </span>

          <span class="gb-pdp-trust__label">
            Manufacturer Warranty
          </span>

        </div>


      </div>




    `;

    return wrapper;
  }


  /* ==========================================================
     Insert / replace purchase assurance block
     ========================================================== */

  function insertTrustBlock() {
    const purchaseArea =
      document.querySelector(
        PURCHASE_SELECTOR
      );

    if (!purchaseArea) {
      return false;
    }


    /*
      Keep Delivery / Trust permanently after Payment Options when
      that module already exists.

      This removes the intermittent mobile load-order race where the
      Delivery / Trust block could rebuild after Payment Options had
      finished reconciling and place itself directly after the ATC.

      Preferred order:
      Purchase / ATC
      Payment Options
      Delivery / Trust

      If Payment Options has not mounted yet, fall back to the
      purchase area. The Payment Options module will then insert
      itself before Delivery / Trust when it mounts.
    */
    const paymentOptions =
      document.querySelector(
        '.product-main .gb-payment-options'
      );

    const insertionAnchor =
      paymentOptions ||
      purchaseArea;


    const existing =
      (
        insertionAnchor.nextElementSibling &&
        insertionAnchor.nextElementSibling.matches(
          TRUST_SELECTOR
        )
      )
        ? insertionAnchor.nextElementSibling
        : null;

    const newBlock =
      createTrustBlock();


    if (existing) {
      existing.replaceWith(
        newBlock
      );
    } else {

      document
        .querySelectorAll(
          TRUST_SELECTOR
        )
        .forEach(
          function (element) {
            element.remove();
          }
        );

      insertionAnchor
        .insertAdjacentElement(
          'afterend',
          newBlock
        );
    }

    return true;
  }


  /* ==========================================================
     Refresh system
     ========================================================== */

  function refreshDeliverySystem() {
    watchVariantSelection();
    insertTrustBlock();
  }


  /* ==========================================================
     Initialization
     ========================================================== */

  function initTrustBlock() {

    watchVariantSelection();

    if (
      insertTrustBlock()
    ) {
      return;
    }


    /*
      If Empire has not rendered the product form yet,
      briefly watch for it.
    */

    const observer =
      new MutationObserver(
        function () {

          if (
            insertTrustBlock()
          ) {
            observer.disconnect();
          }
        }
      );


    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );


    window.setTimeout(
      function () {
        observer.disconnect();
      },
      10000
    );
  }


  /* ==========================================================
     Initial page load
     ========================================================== */

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initTrustBlock
    );
  } else {
    initTrustBlock();
  }


  /* ==========================================================
     Shopify theme editor reload
     ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        refreshDeliverySystem,
        0
      );

    }
  );


  /* ==========================================================
     Product-form / variant changes
     ========================================================== */

  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          '.product-block--form'
        )
      ) {
        window.setTimeout(
          refreshDeliverySystem,
          80
        );
      }

    }
  );


  /* ==========================================================
     Purchase-option / add-on changes
     ========================================================== */

  document.addEventListener(
    'gb:purchase-options-change',
    function () {
      window.setTimeout(
        refreshDeliverySystem,
        0
      );
    }
  );


  /* ==========================================================
     Browser back / forward cache
     ========================================================== */

  window.addEventListener(
    'pageshow',
    function () {

      window.setTimeout(
        refreshDeliverySystem,
        0
      );

    }
  );

})();
















































/* ============================================================
   Gymbuild – Mobile Navigation Scroll Lock
   - Uses Empire's native .site-mobile-nav[data-open] state
   - Freezes the website behind the open mobile drawer
   - Keeps the drawer itself independently scrollable
   - Restores the exact page position when the drawer closes
   - Applies to portrait + landscape mobile only
   ============================================================ */

(function () {
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const root = document.documentElement;
  const body = document.body;

  if (!root || !body) return;

  let mobileNav = null;
  let observer = null;
  let isLocked = false;
  let lockedScrollY = 0;

  /*
    Preserve any inline body styles that existed before
    the drawer opened so we do not overwrite other behavior.
  */
  let previousBodyStyles = null;


  function getMobileNav() {
    return document.querySelector(
      '#site-mobile-nav, .site-mobile-nav'
    );
  }


  function mobileNavIsOpen() {
    return Boolean(
      mobileNav &&
      mobileNav.getAttribute('data-open') === 'true'
    );
  }


  function lockBackgroundScroll() {
    if (!mobileQuery.matches || isLocked) return;

    lockedScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      0;

    previousBodyStyles = {
      position: body.style.position,
      top: body.style.top,
      left: body.style.left,
      right: body.style.right,
      width: body.style.width,
      overflow: body.style.overflow
    };

    root.classList.add('gb-mobile-nav-open');
    body.classList.add('gb-mobile-nav-open');

    /*
      position: fixed is intentionally used instead of relying only
      on overflow:hidden. This is much more reliable on iOS Safari.
    */
    body.style.position = 'fixed';
    body.style.top = `-${lockedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    isLocked = true;
  }


  function unlockBackgroundScroll() {
    if (!isLocked) return;

    root.classList.remove('gb-mobile-nav-open');
    body.classList.remove('gb-mobile-nav-open');

    if (previousBodyStyles) {
      body.style.position = previousBodyStyles.position;
      body.style.top = previousBodyStyles.top;
      body.style.left = previousBodyStyles.left;
      body.style.right = previousBodyStyles.right;
      body.style.width = previousBodyStyles.width;
      body.style.overflow = previousBodyStyles.overflow;
    } else {
      body.style.removeProperty('position');
      body.style.removeProperty('top');
      body.style.removeProperty('left');
      body.style.removeProperty('right');
      body.style.removeProperty('width');
      body.style.removeProperty('overflow');
    }

    window.scrollTo(0, lockedScrollY);

    previousBodyStyles = null;
    isLocked = false;
  }


  function syncMobileNavScrollState() {
    if (!mobileQuery.matches) {
      unlockBackgroundScroll();
      return;
    }

    if (mobileNavIsOpen()) {
      lockBackgroundScroll();
    } else {
      unlockBackgroundScroll();
    }
  }


  function attachMobileNavObserver() {
    mobileNav = getMobileNav();

    if (!mobileNav) return;

    if (observer) {
      observer.disconnect();
    }

    observer = new MutationObserver((mutations) => {
      const openStateChanged = mutations.some(
        (mutation) =>
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-open'
      );

      if (openStateChanged) {
        syncMobileNavScrollState();
      }
    });

    observer.observe(mobileNav, {
      attributes: true,
      attributeFilter: ['data-open']
    });

    syncMobileNavScrollState();
  }


  function handleBreakpointChange() {
    if (!mobileQuery.matches) {
      unlockBackgroundScroll();
    }

    attachMobileNavObserver();
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      attachMobileNavObserver
    );
  } else {
    attachMobileNavObserver();
  }


  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', handleBreakpointChange);
  } else {
    mobileQuery.addListener(handleBreakpointChange);
  }
})();



/* ============================================================
   Gymbuild – Mobile Search Takeover Cancel Cleanup

   Fixes:
   Portrait search -> rotate to landscape -> Cancel after typing.

   - Clears the takeover / inline search value as the takeover closes
   - Notifies Empire's live-search system that the query is now empty
   - Runs only below the desktop breakpoint
   - Does not change normal desktop search behavior
   ============================================================ */

(function () {
  const mobileQuery =
    window.matchMedia(
      '(max-width: 989px)'
    );

  let takeover = null;
  let observer = null;
  let cleanupTimer = null;


  function getTakeover() {
    return document.querySelector(
      '[data-site-header-mobile-search-button] ' +
      '.live-search--takeover'
    );
  }


  function clearMobileSearchState() {
    if (!mobileQuery.matches) {
      return;
    }

    const searchInputs =
      document.querySelectorAll(
        '.site-header [data-live-search-input], ' +
        '.site-header .live-search-form-field'
      );

    searchInputs.forEach(
      function (input) {
        if (!input) {
          return;
        }

        /*
          Preserve the customer's typed search text.

          When a portrait search takeover is rotated into landscape
          and then cancelled, Empire can keep the query in the normal
          landscape search field.

          Preserve that native behavior and only release focus so
          the landscape focus-within shadow does not remain stuck.
        */

        if (
          document.activeElement === input
        ) {
          input.blur();
        }
      }
    );

    document.body.classList.remove(
      'gb-search-glass-active'
    );
  }


  function takeoverIsClosing() {
    return Boolean(
      takeover &&
      takeover.getAttribute(
        'data-animation'
      ) ===
        'open=>closed'
    );
  }


  function scheduleCleanup() {
    clearMobileSearchState();

    if (cleanupTimer) {
      window.clearTimeout(
        cleanupTimer
      );
    }

    cleanupTimer =
      window.setTimeout(
        function () {
          clearMobileSearchState();
          cleanupTimer = null;
        },
        160
      );
  }


  function attachTakeoverObserver() {
    const nextTakeover =
      getTakeover();

    if (!nextTakeover) {
      return;
    }

    if (
      takeover ===
        nextTakeover &&
      observer
    ) {
      return;
    }

    if (observer) {
      observer.disconnect();
    }

    takeover =
      nextTakeover;

    observer =
      new MutationObserver(
        function () {
          if (
            takeoverIsClosing()
          ) {
            scheduleCleanup();
          }
        }
      );

    observer.observe(
      takeover,
      {
        attributes: true,
        attributeFilter: [
          'data-animation',
          'data-animation-state'
        ]
      }
    );
  }


  function initMobileSearchCleanup() {
    attachTakeoverObserver();

    /*
      Empire can re-render header/search markup.
      Watch for a replacement takeover node.
    */

    let documentObserverFrame =
      null;

    const documentObserver =
      new MutationObserver(
        function () {

          if (
            documentObserverFrame
          ) {
            return;
          }

          documentObserverFrame =
            window.requestAnimationFrame(
              function () {

                documentObserverFrame =
                  null;

                attachTakeoverObserver();
              }
            );
        }
      );

    documentObserver.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initMobileSearchCleanup
    );
  } else {
    initMobileSearchCleanup();
  }
})();







































/* ============================================================
   Gymbuild – PDP Sticky Add to Cart
   Desktop + portrait mobile + landscape

   - Runs on Shopify /products/ pages
   - Appears once the real PDP ATC has scrolled above the viewport
   - Shows Gymbuild's live Setup total whenever Purchase Options exists
   - Setup total already includes base quantity + add-ons
   - Falls back to Empire's live current product price on standard products
   - Multiplies the standard-product price by Empire's live quantity
   - Triggers the real Empire Add to Cart button
   - Does not create a second product form
   ============================================================ */

(function () {

  const NATIVE_ATC_SELECTOR =
    '.product-form--atc-button[data-product-atc]';

  const SETUP_TOTAL_SELECTOR =
    '[data-gb-po-setup-total]';

  const NATIVE_PRICING_SELECTOR =
    '.product-main [data-product-pricing], ' +
    '.product-main .product-pricing';

  const NATIVE_PRICE_SELECTOR =
    '[data-price-container] [data-price], ' +
    '.price__current:not(.price__current--hidden) [data-price]';

  const VISIBLE_CLASS =
    'gb-sticky-atc--visible';


  let nativeButton = null;
  let setupTotal = null;
  let nativePricing = null;

  let stickyBar = null;
  let stickyButton = null;
  let stickyLabel = null;
  let stickyPrice = null;

  let nativeObserver = null;
  let totalObserver = null;
  let priceObserver = null;

  let frame = null;


  /* ==========================================================
     Product-page check

     Gymbuild's Empire body does not use template-product,
     so use Shopify's product URL structure instead.
     ========================================================== */

  function isProductPage() {

    return (
      window.location.pathname
        .toLowerCase()
        .startsWith('/products/')
    );
  }


  /* ==========================================================
     Live PDP references
     ========================================================== */

  function getNativeButton() {

    return document.querySelector(
      NATIVE_ATC_SELECTOR
    );
  }


  function getSetupTotal() {

    return document.querySelector(
      SETUP_TOTAL_SELECTOR
    );
  }


  function getNativePricing() {

    return document.querySelector(
      NATIVE_PRICING_SELECTOR
    );
  }


  function getNativePrice() {

    const pricing =
      getNativePricing();

    if (!pricing) {
      return null;
    }

    return pricing.querySelector(
      NATIVE_PRICE_SELECTOR
    );
  }


  /* ==========================================================
     Sticky price

     Priority:
     1. Purchase Options Setup total (base quantity + add-ons)
     2. Empire's live current product price for standard products
     ========================================================== */

  function getCleanText(element) {

    if (!element) {
      return '';
    }

    return (
      element.textContent || ''
    )
      .replace(/\s+/g, ' ')
      .trim();
  }


  function getSetupTotalText() {

    return getCleanText(
      getSetupTotal()
    );
  }


  function getNativePriceText() {

    return getCleanText(
      getNativePrice()
    );
  }


  function getNativeQuantityInput() {

    const productForm =
      nativeButton &&
      nativeButton.closest('form');


    if (productForm) {

      const formQuantityInput =
        productForm.querySelector(
          '.product-form--quantity input[name="quantity"], ' +
          'input[name="quantity"]'
        );

      if (formQuantityInput) {
        return formQuantityInput;
      }
    }


    return document.querySelector(
      '.product-form--quantity input[name="quantity"], ' +
      '.product-form--quantity input[type="number"], ' +
      'input[name="quantity"]'
    );
  }


  function getNativeQuantity() {

    const input =
      getNativeQuantityInput();

    if (!input) {
      return 1;
    }


    const quantity =
      Number.parseInt(
        input.value,
        10
      );


    return (
      Number.isFinite(quantity) &&
      quantity > 0
    )
      ? quantity
      : 1;
  }


  function parseNativeMoneyAmount(
    priceText
  ) {

    if (!priceText) {
      return null;
    }


    const normalized =
      priceText
        .replace(/,/g, '')
        .replace(/[^0-9.-]/g, '');


    if (!normalized) {
      return null;
    }


    const amount =
      Number.parseFloat(
        normalized
      );


    return Number.isFinite(amount)
      ? amount
      : null;
  }


  function formatNativeMoneyAmount(
    amount
  ) {

    const currency =
      (
        window.Shopify &&
        window.Shopify.currency &&
        window.Shopify.currency.active
      ) ||
      'USD';


    const locale =
      document.documentElement.lang ||
      'en-US';


    try {

      return new Intl.NumberFormat(
        locale,
        {
          style: 'currency',
          currency: currency
        }
      ).format(amount);

    } catch (error) {

      return '$' +
        amount.toLocaleString(
          'en-US',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        );
    }
  }


  function getStandardProductTotalText() {

    const nativePriceText =
      getNativePriceText();

    if (!nativePriceText) {
      return '';
    }


    const quantity =
      getNativeQuantity();

    if (quantity <= 1) {
      return nativePriceText;
    }


    const unitAmount =
      parseNativeMoneyAmount(
        nativePriceText
      );

    if (unitAmount === null) {
      return nativePriceText;
    }


    return formatNativeMoneyAmount(
      unitAmount * quantity
    );
  }


  function getStickyPriceText() {

    const setupTotalText =
      getSetupTotalText();

    if (setupTotalText) {
      return setupTotalText;
    }

    return getStandardProductTotalText();
  }


  /* ==========================================================
     Native button text
     ========================================================== */

  function getNativeButtonText() {

    if (!nativeButton) {
      return 'Add to cart';
    }


    const textElement =
      nativeButton.querySelector(
        '.atc-button--text'
      );


    const text =
      (
        textElement
          ? textElement.textContent
          : nativeButton.textContent
      )
        .replace(/\s+/g, ' ')
        .trim();


    return (
      text ||
      'Add to cart'
    );
  }


  /* ==========================================================
     Native ATC state
     ========================================================== */

  function nativeButtonIsProcessing() {

    return Boolean(
      nativeButton &&
      nativeButton.classList.contains(
        'processing'
      )
    );
  }


  function nativeButtonIsUnavailable() {

    if (!nativeButton) {
      return true;
    }


    const text =
      (
        nativeButton.textContent || ''
      )
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();


    const processing =
      nativeButtonIsProcessing();


    return Boolean(
      !processing &&
      (
        nativeButton.disabled ||
        nativeButton.getAttribute(
          'aria-disabled'
        ) === 'true' ||
        text.includes('sold out') ||
        text.includes('unavailable')
      )
    );
  }


  /* ==========================================================
     Create sticky ATC
     ========================================================== */

  function createStickyBar() {

    if (
      stickyBar ||
      !nativeButton
    ) {
      return;
    }


    stickyBar =
      document.createElement(
        'div'
      );

    stickyBar.className =
      'gb-sticky-atc';

    stickyBar.setAttribute(
      'aria-hidden',
      'true'
    );


    stickyButton =
      document.createElement(
        'button'
      );

    stickyButton.type =
      'button';

    stickyButton.className =
      'gb-sticky-atc__button';


    stickyButton.innerHTML = `

      <span
        class="gb-sticky-atc__cart"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          focusable="false"
        >
          <path
            d="M3.5 5h2l1.8 9h9.8l2-6.5H6.2"
          ></path>

          <circle
            cx="9"
            cy="18.5"
            r="1.4"
          ></circle>

          <circle
            cx="17"
            cy="18.5"
            r="1.4"
          ></circle>
        </svg>
      </span>

      <span
        class="gb-sticky-atc__label"
      >
        Add to cart
      </span>

      <span
        class="gb-sticky-atc__separator"
        aria-hidden="true"
      >
        •
      </span>

      <span
        class="gb-sticky-atc__price"
      ></span>

      <span
        class="gb-sticky-atc__spinner"
        aria-hidden="true"
      ></span>

    `;


    stickyLabel =
      stickyButton.querySelector(
        '.gb-sticky-atc__label'
      );

    stickyPrice =
      stickyButton.querySelector(
        '.gb-sticky-atc__price'
      );


    stickyButton.addEventListener(
      'click',
      function () {

        refreshReferences();


        if (
          !nativeButton ||
          nativeButtonIsProcessing() ||
          nativeButtonIsUnavailable()
        ) {
          return;
        }


        /*
          Use the real PDP button so all existing Gymbuild
          quantity, add-on, variant and cart behavior remains intact.
        */

        nativeButton.click();

      }
    );


    stickyBar.appendChild(
      stickyButton
    );

    document.body.appendChild(
      stickyBar
    );


    syncStickyState();
  }


  /* ==========================================================
     Sync label + price + disabled state
     ========================================================== */

  function syncStickyState() {

    if (
      !stickyButton ||
      !nativeButton
    ) {
      return;
    }


    const label =
      getNativeButtonText();

    const price =
      getStickyPriceText();

    const processing =
      nativeButtonIsProcessing();

    const unavailable =
      nativeButtonIsUnavailable();

    const disabled =
      processing ||
      unavailable;


    stickyLabel.textContent =
      label;


    stickyButton.disabled =
      disabled;


    stickyButton.setAttribute(
      'aria-disabled',
      disabled
        ? 'true'
        : 'false'
    );


    stickyButton.classList.toggle(
      'gb-sticky-atc__button--processing',
      processing
    );


    stickyButton.classList.toggle(
      'gb-sticky-atc__button--disabled',
      unavailable
    );


    if (price) {

      stickyPrice.textContent =
        price;

      stickyPrice.hidden =
        false;

      stickyButton.classList.remove(
        'gb-sticky-atc__button--no-price'
      );

    } else {

      stickyPrice.textContent =
        '';

      stickyPrice.hidden =
        true;

      stickyButton.classList.add(
        'gb-sticky-atc__button--no-price'
      );
    }
  }


  /* ==========================================================
     Observe native ATC
     ========================================================== */

  function observeNativeButton() {

    if (nativeObserver) {
      nativeObserver.disconnect();
    }


    if (!nativeButton) {
      return;
    }


    nativeObserver =
      new MutationObserver(
        syncStickyState
      );


    nativeObserver.observe(
      nativeButton,
      {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  /* ==========================================================
     Observe live Setup total
     ========================================================== */

  function observeSetupTotal() {

    if (totalObserver) {
      totalObserver.disconnect();
    }


    setupTotal =
      getSetupTotal();


    if (!setupTotal) {
      return;
    }


    totalObserver =
      new MutationObserver(
        syncStickyState
      );


    totalObserver.observe(
      setupTotal,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  /* ==========================================================
     Observe Empire's live product pricing

     Standard products do not render Gymbuild's Setup total.
     Watching Empire's pricing container keeps the sticky price
     synchronized if the current variant / price changes.
     ========================================================== */

  function observeNativePricing() {

    if (priceObserver) {
      priceObserver.disconnect();
    }


    nativePricing =
      getNativePricing();


    if (!nativePricing) {
      return;
    }


    priceObserver =
      new MutationObserver(
        syncStickyState
      );


    priceObserver.observe(
      nativePricing,
      {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  /* ==========================================================
     Refresh references
     ========================================================== */

  function refreshReferences() {

    const newNativeButton =
      getNativeButton();


    if (
      newNativeButton !==
      nativeButton
    ) {

      nativeButton =
        newNativeButton;

      observeNativeButton();
    }


    const newSetupTotal =
      getSetupTotal();


    if (
      newSetupTotal !==
      setupTotal
    ) {

      setupTotal =
        newSetupTotal;

      observeSetupTotal();
    }


    const newNativePricing =
      getNativePricing();


    if (
      newNativePricing !==
      nativePricing
    ) {

      nativePricing =
        newNativePricing;

      observeNativePricing();
    }


    if (
      nativeButton &&
      !stickyBar
    ) {
      createStickyBar();
    }


    syncStickyState();
  }


  /* ==========================================================
     Hide behind mobile navigation/search takeover
     ========================================================== */

  function mobileOverlayIsOpen() {

    if (
      document.querySelector(
        '#site-mobile-nav[data-open="true"], ' +
        '.site-mobile-nav[data-open="true"]'
      )
    ) {
      return true;
    }


    return Boolean(
      document.querySelector(

        '[data-site-header-mobile-search-button] ' +
        '.live-search--takeover' +
        '[data-animation-state="open"], ' +

        '[data-site-header-mobile-search-button] ' +
        '.live-search--takeover' +
        '[data-animation="closed=>open"]'

      )
    );
  }


  /* ==========================================================
     Sticky visibility
     ========================================================== */

  function updateVisibility() {

    frame = null;


    refreshReferences();


    if (
      !stickyBar ||
      !nativeButton
    ) {
      return;
    }


    const rect =
      nativeButton
        .getBoundingClientRect();


    /*
      Show only once the real PDP ATC has completely
      scrolled above the viewport.
    */

    const passedNativeButton =
      rect.bottom <= 8;


    const shouldShow =
      passedNativeButton &&
      !mobileOverlayIsOpen();


    stickyBar.classList.toggle(
      VISIBLE_CLASS,
      shouldShow
    );


    stickyBar.setAttribute(
      'aria-hidden',
      shouldShow
        ? 'false'
        : 'true'
    );
  }


  function requestVisibilityUpdate() {

    if (frame) {
      return;
    }


    frame =
      window.requestAnimationFrame(
        updateVisibility
      );
  }


  /* ==========================================================
     Initialize
     ========================================================== */

  function initStickyATC() {

    if (!isProductPage()) {
      return;
    }


    refreshReferences();


    /*
      Briefly watch in case Shopify renders the native ATC or
      live price container after this script initializes.
    */

    if (
      !nativeButton ||
      (
        !setupTotal &&
        !nativePricing
      )
    ) {

      const pageObserver =
        new MutationObserver(
          function () {

            refreshReferences();

            if (
              nativeButton &&
              (
                setupTotal ||
                nativePricing
              )
            ) {

              pageObserver.disconnect();

              requestVisibilityUpdate();
            }

          }
        );


      pageObserver.observe(
        document.documentElement,
        {
          childList: true,
          subtree: true
        }
      );


      window.setTimeout(
        function () {

          pageObserver.disconnect();

        },
        10000
      );
    }


    window.addEventListener(
      'scroll',
      requestVisibilityUpdate,
      {
        passive: true
      }
    );


    window.addEventListener(
      'resize',
      requestVisibilityUpdate
    );


    window.addEventListener(
      'orientationchange',
      function () {

        window.setTimeout(
          requestVisibilityUpdate,
          120
        );

      }
    );


    /*
      Quantity / add-on / variant changes.
      Purchase Options already updates Setup total when present.
      Standard products use Empire's live quantity to calculate
      quantity × current unit price for the sticky ATC total.
    */

    document.addEventListener(
      'change',
      function () {

        window.setTimeout(
          function () {

            refreshReferences();
            syncStickyState();

          },
          50
        );

      }
    );


    document.addEventListener(
      'click',
      function (event) {

        if (
          event.target &&
          event.target.closest &&
          (
            event.target.closest(
              '[data-gb-po-plus]'
            ) ||
            event.target.closest(
              '[data-gb-po-minus]'
            ) ||
            event.target.closest(
              '.product-form--quantity'
            )
          )
        ) {

          window.setTimeout(
            syncStickyState,
            50
          );
        }

      }
    );


    requestVisibilityUpdate();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initStickyATC
    );

  } else {

    initStickyATC();
  }

})();

















































/* ============================================================
   Gymbuild – PDP Payment Options
   Pay in full + Monthly / Affirm

   CURRENT PREFERRED VERSION

   Final intended placement:

   Compatible Attachments & Upgrades
   Setup total
   Quantity
   Add to cart
   Payment Options
   Estimated ship date
   Trust badges

   Important:
   - Works with Gymbuild's custom Purchase Options mounting
   - Re-checks placement while other PDP scripts finish loading
   - Keeps Payment Options immediately before .gb-pdp-trust
   - Uses the real live Affirm block
   - Preserves dynamic Affirm pricing
   - Preserves Affirm Learn more modal
   - "+ more" remains static / non-clickable
   ============================================================ */

(function () {
  'use strict';

  const MODULE_CLASS = 'gb-payment-options';


  /* ============================================================
     PAYMENT METHODS
     ============================================================ */

  const PAYMENT_METHODS = [

    {
      name: 'Visa',
      svg: `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          viewBox="0 0 38 24"
          width="38"
          height="24"
          fill="none"
          aria-label="Visa"
        >
          <rect
            x=".5"
            y=".5"
            width="37"
            height="23"
            rx="2.5"
            stroke="#000"
            stroke-opacity=".07"
            fill="none"
          ></rect>

          <path
            d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
            fill="#142FBD"
          ></path>

          <path
            d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z"
            fill="#1532CB"
          ></path>

          <path
            d="M29.5944 10.2167H29.2778C28.8556 11.2722 28.5389 11.8 28.2222 13.3833H30.2278C29.9111 11.8 29.9111 11.0611 29.5944 10.2167V10.2167ZM32.6556 16.4444H30.8611C30.7556 16.4444 30.7556 16.4444 30.65 16.3389L30.4389 15.3889L30.3333 15.1778H27.8C27.6944 15.1778 27.5889 15.1778 27.5889 15.3889L27.2722 16.3389C27.2722 16.4444 27.1667 16.4444 27.1667 16.4444H24.95L25.1611 15.9167L28.2222 8.73889C28.2222 8.21111 28.5389 8 29.0667 8H30.65C30.7556 8 30.8611 8 30.8611 8.21111L32.3389 15.0722C32.4444 15.4944 32.55 15.8111 32.55 16.2333C32.6556 16.3389 32.6556 16.3389 32.6556 16.4444V16.4444ZM18.5111 16.1278L18.9333 14.2278C19.0389 14.2278 19.1444 14.3333 19.1444 14.3333C19.8833 14.65 20.6222 14.8611 21.3611 14.7556C21.5722 14.7556 21.8889 14.65 22.1 14.5444C22.6278 14.3333 22.6278 13.8056 22.2056 13.3833C21.9944 13.1722 21.6778 13.0667 21.3611 12.8556C20.9389 12.6444 20.5167 12.4333 20.2 12.1167C18.9333 11.0611 19.3556 9.58333 20.0944 8.84444C20.7278 8.42222 21.0444 8 21.8889 8C23.1556 8 24.5278 8 25.1611 8.21111H25.2667C25.1611 8.84444 25.0556 9.37222 24.8444 10.0056C24.3167 9.79444 23.7889 9.58333 23.2611 9.58333C22.9444 9.58333 22.6278 9.58333 22.3111 9.68889C22.1 9.68889 21.9944 9.79444 21.8889 9.9C21.6778 10.1111 21.6778 10.4278 21.8889 10.6389L22.4167 11.0611C22.8389 11.2722 23.2611 11.4833 23.5778 11.6944C24.1056 12.0111 24.6333 12.5389 24.7389 13.1722C24.95 14.1222 24.6333 14.9667 23.7889 15.6C23.2611 16.0222 23.05 16.2333 22.3111 16.2333C20.8333 16.2333 19.6722 16.3389 18.7222 16.0222C18.6167 16.2333 18.6167 16.2333 18.5111 16.1278V16.1278ZM14.8167 16.4444C14.9222 15.7056 14.9222 15.7056 15.0278 15.3889C15.5556 13.0667 16.0833 10.6389 16.5056 8.31667C16.6111 8.10556 16.6111 8 16.8222 8H18.7222C18.5111 9.26667 18.3 10.2167 17.9833 11.3778C17.6667 12.9611 17.35 14.5444 16.9278 16.1278C16.9278 16.3389 16.8222 16.3389 16.6111 16.3389L14.8167 16.4444ZM5 8.21111C5 8.10556 5.21111 8 5.31667 8H8.90556C9.43333 8 9.85556 8.31667 9.96111 8.84444L10.9111 13.4889C10.9111 13.5944 10.9111 13.5944 11.0167 13.7C11.0167 13.5944 11.1222 13.5944 11.1222 13.5944L13.3389 8.21111C13.2333 8.10556 13.3389 8 13.4444 8H15.6611C15.6611 8.10556 15.6611 8.10556 15.5556 8.21111L12.2833 15.9167C12.1778 16.1278 12.1778 16.2333 12.0722 16.3389C11.9667 16.4444 11.7556 16.3389 11.5444 16.3389H9.96111C9.85556 16.3389 9.75 16.3389 9.75 16.1278L8.06111 9.58333C7.85 9.37222 7.53333 9.05556 7.11111 8.95C6.47778 8.63333 5.31667 8.42222 5.10556 8.42222L5 8.21111Z"
            fill="white"
          ></path>
        </svg>
      `
    },


    {
      name: 'Mastercard',
      svg: `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          viewBox="0 0 38 24"
          width="38"
          height="24"
          fill="none"
          aria-label="Mastercard"
        >
          <path
            d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
            fill="#1C1C1C"
          ></path>

          <path
            d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z"
            fill="#232323"
          ></path>

          <path
            d="M14.6364 19.2727C18.8538 19.2727 22.2727 15.8538 22.2727 11.6364C22.2727 7.41892 18.8538 4 14.6364 4C10.4189 4 7 7.41892 7 11.6364C7 15.8538 10.4189 19.2727 14.6364 19.2727Z"
            fill="#EB001B"
          ></path>

          <path
            d="M23.3637 19.2727C27.5811 19.2727 31 15.8538 31 11.6364C31 7.41892 27.5811 4 23.3637 4C19.1462 4 15.7273 7.41892 15.7273 11.6364C15.7273 15.8538 19.1462 19.2727 23.3637 19.2727Z"
            fill="#F79E1B"
          ></path>

          <path
            d="M22.2727 11.6362C22.2727 9.01797 20.9637 6.72706 19 5.41797C17.0364 6.83615 15.7273 9.12706 15.7273 11.6362C15.7273 14.1452 17.0364 16.5452 19 17.8543C20.9637 16.5452 22.2727 14.2543 22.2727 11.6362Z"
            fill="#FF5F00"
          ></path>
        </svg>
      `
    },


    {
      name: 'American Express',
      svg: `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          viewBox="0 0 38 24"
          width="38"
          height="24"
          fill="none"
          aria-label="American Express"
        >
          <path
            d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z"
            fill="#0071CE"
          ></path>

          <path
            d="M25.8662 6.33203V3H31L31.8662 5.5332L32.7334 3H37V14.2002H36.7998L34.8672 16.2656L36.7998 18.3594H37V21.2666H33.5996L31.9336 19.3994L30.2002 21.2666H19.4668V12.666H16L20.2666 3H24.4004L25.8662 6.33203ZM20.5996 20.2656H27V18.5322H22.666V17.3994H26.8662V15.666H22.666V14.5322H27V12.7988H20.5996V20.2656ZM30.5332 16.5322L27 20.2656H29.5996L31.8662 17.8662L34.0664 20.2656H36.7324L33.1992 16.4658L36.7324 12.7988H34.1328L31.8662 15.1992L29.7324 12.7988H27L30.5332 16.5322ZM17.666 11.7324H19.9326L20.5332 10.1992H23.999L24.666 11.7324H26.999L23.666 4.19922H20.999L17.666 11.7324ZM33.5996 4.19922L31.9326 8.86621L30.1992 4.19922H27V11.666H29.0664V6.39941L31 11.666H32.7998L34.7324 6.39941V11.666H36.7324V4.13281L33.5996 4.19922ZM23.2656 8.46582H21.2656L22.2656 5.99902L23.2656 8.46582Z"
            fill="white"
          ></path>
        </svg>
      `
    },


    {
      name: 'Apple Pay',
      svg: `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          width="38"
          height="24"
          viewBox="0 0 165.521 105.965"
          aria-label="Apple Pay"
        >
          <path
            fill="#000"
            d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"
          ></path>

          <path
            fill="#FFF"
            d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"
          ></path>

          <g fill="#000">
            <path d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path>
            <path d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path>
            <path d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path>
            <path d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path>
            <path d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path>
          </g>
        </svg>
      `
    },


    


    {
      name: 'PayPal',
      svg: `
        <svg
          viewBox="0 0 38 24"
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="24"
          role="img"
          aria-label="PayPal"
        >
          <path
            opacity=".07"
            d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
          ></path>

          <path
            fill="#fff"
            d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
          ></path>

          <path
            fill="#003087"
            d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"
          ></path>

          <path
            fill="#3086C8"
            d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"
          ></path>

          <path
            fill="#012169"
            d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"
          ></path>
        </svg>
      `
    },


    {
      name: 'Shop Pay',
      svg: `
        <svg
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          viewBox="0 0 38 24"
          width="38"
          height="24"
          aria-label="Shop Pay"
        >
          <path
            d="M35.889 0C37.05 0 38 .982 38 2.182v19.636c0 1.2-.95 2.182-2.111 2.182H2.11C.95 24 0 23.018 0 21.818V2.182C0 .982.95 0 2.111 0H35.89z"
            fill="#5A31F4"
          ></path>

          <path
            d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003zM15.49 8.855c-.65 0-1.224.232-1.636.646a.04.04 0 01-.069-.03v-2.64a.08.08 0 00-.08-.081H12.27a.08.08 0 00-.08.082v8.194a.08.08 0 00.08.082h1.433a.08.08 0 00.081-.082v-3.594c0-.695.528-1.227 1.239-1.227.71 0 1.226.521 1.226 1.227v3.594a.08.08 0 00.081.082h1.433a.08.08 0 00.081-.082v-3.594c0-1.51-.981-2.577-2.355-2.577zM20.753 8.62c-.778 0-1.507.24-2.03.588a.082.082 0 00-.027.109l.632 1.088a.08.08 0 00.11.03 2.5 2.5 0 011.318-.366c1.25 0 2.17.891 2.17 2.068 0 1.003-.736 1.745-1.669 1.745-.76 0-1.288-.446-1.288-1.077 0-.361.152-.657.548-.866a.08.08 0 00.032-.113l-.596-1.018a.08.08 0 00-.098-.035c-.799.299-1.359 1.018-1.359 1.984 0 1.46 1.152 2.55 2.76 2.55 1.877 0 3.227-1.313 3.227-3.195 0-2.018-1.57-3.492-3.73-3.492zM28.675 8.843c-.724 0-1.373.27-1.845.746-.026.027-.069.007-.069-.029v-.572a.08.08 0 00-.08-.082h-1.397a.08.08 0 00-.08.082v8.182a.08.08 0 00.08.081h1.433a.08.08 0 00.081-.081v-2.683c0-.036.043-.054.069-.03a2.6 2.6 0 001.808.7c1.682 0 2.993-1.373 2.993-3.157s-1.313-3.157-2.993-3.157zm-.271 4.929c-.956 0-1.681-.768-1.681-1.783s.723-1.783 1.681-1.783c.958 0 1.68.755 1.68 1.783 0 1.027-.713 1.783-1.681 1.783h.001z"
            fill="#fff"
          ></path>
        </svg>
      `
    }

  ];


  /* ============================================================
     BUILD PAYMENT ICON ROW
     ============================================================ */

  function buildPaymentIconList() {

    const list =
      document.createElement('ul');

    list.className =
      'gb-payment-options__icons';

    list.setAttribute(
      'aria-label',
      'Accepted payment methods'
    );


    PAYMENT_METHODS.forEach(
      function (payment) {

        const item =
          document.createElement('li');

        item.className =
          'gb-payment-options__icon';

        item.setAttribute(
          'title',
          payment.name
        );

        item.innerHTML =
          payment.svg.trim();

        list.appendChild(
          item
        );
      }
    );


    const moreItem =
      document.createElement('li');

    moreItem.className =
      'gb-payment-options__more-item';


    const moreLabel =
      document.createElement('span');

    moreLabel.className =
      'gb-payment-options__more';

    moreLabel.textContent =
      '+ more';

    moreLabel.setAttribute(
      'aria-label',
      'More payment methods available'
    );


    moreItem.appendChild(
      moreLabel
    );

    list.appendChild(
      moreItem
    );


    return list;
  }


  /* ============================================================
     TAB STATE
     ============================================================ */

  function setActiveTab(
    module,
    selectedName
  ) {

    if (!module) {
      return;
    }


    const tabs =
      Array.from(
        module.querySelectorAll(
          '[role="tab"]'
        )
      );


    const panels =
      Array.from(
        module.querySelectorAll(
          '[role="tabpanel"]'
        )
      );


    tabs.forEach(
      function (tab) {

        const selected =
          tab.dataset.gbPaymentTab ===
          selectedName;


        tab.setAttribute(
          'aria-selected',
          selected
            ? 'true'
            : 'false'
        );


        tab.tabIndex =
          selected
            ? 0
            : -1;
      }
    );


    panels.forEach(
      function (panel) {

        panel.hidden =
          panel.dataset.gbPaymentPanel !==
          selectedName;
      }
    );
  }


  function attachTabBehavior(
    module
  ) {

    const tabs =
      Array.from(
        module.querySelectorAll(
          '[role="tab"]'
        )
      );


    tabs.forEach(
      function (
        tab,
        index
      ) {

        tab.addEventListener(
          'click',
          function () {

            setActiveTab(
              module,
              tab.dataset.gbPaymentTab
            );
          }
        );


        tab.addEventListener(
          'keydown',
          function (event) {

            if (
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight'
            ) {
              return;
            }


            event.preventDefault();


            const direction =
              event.key === 'ArrowRight'
                ? 1
                : -1;


            const nextIndex =
              (
                index +
                direction +
                tabs.length
              ) %
              tabs.length;


            const nextTab =
              tabs[nextIndex];


            setActiveTab(
              module,
              nextTab.dataset.gbPaymentTab
            );


            nextTab.focus();
          }
        );
      }
    );
  }


  /* ============================================================
     BUILD MODULE
     ============================================================ */

  function createPaymentModule(
    affirmBlock,
    iconList
  ) {

    const module =
      document.createElement(
        'section'
      );


    module.className =
      'product-block ' +
      MODULE_CLASS;


    module.setAttribute(
      'aria-label',
      'Payment options'
    );


    /* Heading */

    const heading =
      document.createElement(
        'div'
      );

    heading.className =
      'gb-payment-options__heading';

    heading.textContent =
      'Payment Options';


    /* Tab list */

    const tabs =
      document.createElement(
        'div'
      );

    tabs.className =
      'gb-payment-options__tabs';

    tabs.setAttribute(
      'role',
      'tablist'
    );

    tabs.setAttribute(
      'aria-label',
      'Choose a payment option'
    );


    /* Pay in full tab */

    const payFullTab =
      document.createElement(
        'button'
      );

    payFullTab.type =
      'button';

    payFullTab.className =
      'gb-payment-options__tab';

    payFullTab.id =
      'gb-payment-tab-full';

    payFullTab.setAttribute(
      'role',
      'tab'
    );

    payFullTab.setAttribute(
      'aria-controls',
      'gb-payment-panel-full'
    );

    payFullTab.dataset.gbPaymentTab =
      'full';

    payFullTab.textContent =
      'Pay in full';


    /* Monthly tab */

    const monthlyTab =
      document.createElement(
        'button'
      );

    monthlyTab.type =
      'button';

    monthlyTab.className =
      'gb-payment-options__tab';

    monthlyTab.id =
      'gb-payment-tab-monthly';

    monthlyTab.setAttribute(
      'role',
      'tab'
    );

    monthlyTab.setAttribute(
      'aria-controls',
      'gb-payment-panel-monthly'
    );

    monthlyTab.dataset.gbPaymentTab =
      'monthly';

    monthlyTab.textContent =
      'Monthly';


    tabs.appendChild(
      payFullTab
    );

    tabs.appendChild(
      monthlyTab
    );


    /* Pay in full panel */

    const fullPanel =
      document.createElement(
        'div'
      );

    fullPanel.className =
      'gb-payment-options__panel ' +
      'gb-payment-options__panel--full';

    fullPanel.id =
      'gb-payment-panel-full';

    fullPanel.setAttribute(
      'role',
      'tabpanel'
    );

    fullPanel.setAttribute(
      'aria-labelledby',
      payFullTab.id
    );

    fullPanel.dataset.gbPaymentPanel =
      'full';

    fullPanel.appendChild(
      iconList
    );


    /* Monthly / Affirm panel */

    const monthlyPanel =
      document.createElement(
        'div'
      );

    monthlyPanel.className =
      'gb-payment-options__panel ' +
      'gb-payment-options__panel--monthly';

    monthlyPanel.id =
      'gb-payment-panel-monthly';

    monthlyPanel.setAttribute(
      'role',
      'tabpanel'
    );

    monthlyPanel.setAttribute(
      'aria-labelledby',
      monthlyTab.id
    );

    monthlyPanel.dataset.gbPaymentPanel =
      'monthly';


    const monthlyContent =
      document.createElement(
        'div'
      );

    monthlyContent.className =
      'gb-payment-options__monthly';


    /*
      Move the REAL live Affirm product block.

      This preserves:
      - current product price
      - dynamic monthly calculation
      - APR messaging
      - native Affirm logo
      - Learn more modal
    */

    affirmBlock.classList.add(
      'gb-payment-options__affirm-block'
    );


    monthlyContent.appendChild(
      affirmBlock
    );


    monthlyPanel.appendChild(
      monthlyContent
    );


    /* Assemble */

    module.appendChild(
      heading
    );

    module.appendChild(
      tabs
    );

    module.appendChild(
      fullPanel
    );

    module.appendChild(
      monthlyPanel
    );


    attachTabBehavior(
      module
    );


    /*
      Default state:
      Pay in full
    */

    setActiveTab(
      module,
      'full'
    );


    return module;
  }


  /* ============================================================
     POSITION MODULE
     ============================================================ */

  function positionPaymentOptions(
    module
  ) {

    if (!module) {
      return false;
    }


    const atcContainer =
      document.querySelector(
        '.product-main .product-form--atc'
      );


    const trustBlock =
      document.querySelector(
        '.product-main .gb-pdp-trust'
      );


    /*
      FINAL PREFERRED POSITION

      Once the trust block exists, Payment Options should
      always be immediately before it.

      Intended structure:

      .product-form--atc
      .gb-payment-options
      .gb-pdp-trust
    */

    if (
      trustBlock &&
      trustBlock.parentNode
    ) {

      if (
        module.parentNode !==
          trustBlock.parentNode ||
        module.nextElementSibling !==
          trustBlock
      ) {

        trustBlock.parentNode.insertBefore(
          module,
          trustBlock
        );
      }


      return true;
    }


    /*
      EARLY LOAD FALLBACK

      The trust/delivery module may not have mounted yet.

      Temporarily put Payment Options directly after the full
      ATC container. Once .gb-pdp-trust appears, the observer
      below will confirm/reposition it.
    */

    if (
      atcContainer &&
      atcContainer.parentNode
    ) {

      if (
        module.parentNode !==
          atcContainer.parentNode ||
        atcContainer.nextElementSibling !==
          module
      ) {

        atcContainer.insertAdjacentElement(
          'afterend',
          module
        );
      }


      return true;
    }


    return false;
  }


  /* ============================================================
     INITIALIZE
     ============================================================ */

  function initPaymentOptions() {

    /*
      Module may already exist.

      Do not simply return, because another Gymbuild PDP script
      may have mounted after us and changed surrounding DOM order.
    */

    const existingModule =
      document.querySelector(
        '.' + MODULE_CLASS
      );


    if (existingModule) {

      positionPaymentOptions(
        existingModule
      );


      return true;
    }


    /*
      Find live Affirm message.
    */

    const affirmMessage =
      document.querySelector(
        '.product-main .affirm-as-low-as'
      );


    if (!affirmMessage) {
      return false;
    }


    /*
      Find Shopify product block containing Affirm.
    */

    const affirmBlock =
      affirmMessage.closest(
        '.product-block'
      );


    if (
      !affirmBlock ||
      !affirmBlock.parentNode
    ) {
      return false;
    }


    /*
      Save original Affirm position BEFORE moving it into
      Payment Options.
    */

    const originalParent =
      affirmBlock.parentNode;


    const originalNextSibling =
      affirmBlock.nextSibling;


    /*
      Build module.
    */

    const iconList =
      buildPaymentIconList();


    const module =
      createPaymentModule(
        affirmBlock,
        iconList
      );


    /*
      Attempt preferred placement.
    */

    if (
      positionPaymentOptions(
        module
      )
    ) {
      return true;
    }


    /*
      Ultimate fallback.

      If neither custom Gymbuild anchor exists yet,
      place it where Affirm originally lived.
    */

    originalParent.insertBefore(
      module,
      originalNextSibling
    );


    return true;
  }


  /* ============================================================
     START / DOM RECONCILIATION
     ============================================================ */

  function startPaymentOptions() {

    /*
      Initial creation / placement.
    */

    initPaymentOptions();


    const watchTarget =
      document.querySelector(
        '.product-main'
      ) ||
      document.body;


    if (!watchTarget) {
      return;
    }


    let framePending = false;


    /*
      Gymbuild Purchase Options and trust/delivery modules can
      continue mounting after initial page render.

      Watch DOM changes briefly and continuously restore the
      intended relationship:

      ATC
      Payment Options
      Trust / Delivery
    */

    const observer =
      new MutationObserver(
        function () {

          if (framePending) {
            return;
          }


          framePending = true;


          window.requestAnimationFrame(
            function () {

              framePending = false;


              const module =
                document.querySelector(
                  '.' + MODULE_CLASS
                );


              if (!module) {

                initPaymentOptions();

                return;
              }


              positionPaymentOptions(
                module
              );
            }
          );
        }
      );


    observer.observe(
      watchTarget,
      {
        childList: true,
        subtree: true
      }
    );


    /*
      Explicit checks during the same period Gymbuild's custom
      modules are doing their delayed mounting.

      These also protect against changes that do not happen at
      exactly the same moment as an observed mutation.
    */

    [
      50,
      100,
      200,
      350,
      500,
      750,
      1000,
      1400,
      1800,
      2200,
      3000
    ].forEach(
      function (delay) {

        window.setTimeout(
          function () {

            const module =
              document.querySelector(
                '.' + MODULE_CLASS
              );


            if (module) {

              positionPaymentOptions(
                module
              );

            } else {

              initPaymentOptions();
            }

          },
          delay
        );
      }
    );


    /*
      Keep reconciliation running beyond the Purchase Options
      mounting window, then perform one final position check.
    */

    window.setTimeout(
      function () {

        const module =
          document.querySelector(
            '.' + MODULE_CLASS
          );


        if (module) {

          positionPaymentOptions(
            module
          );
        }


        observer.disconnect();

      },
      4500
    );
  }


  /* ============================================================
     STARTUP
     ============================================================ */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      startPaymentOptions
    );

  } else {

    startPaymentOptions();
  }


  /* ============================================================
     SHOPIFY THEME EDITOR SUPPORT
     ============================================================ */

  document.addEventListener(
    'shopify:section:load',
    function () {

      window.setTimeout(
        startPaymentOptions,
        50
      );
    }
  );

})();






































/* ============================================================
   Gymbuild – Homepage Trust Section Identity Bridge
   Stable selector bridge for the finalized Meta-style homepage
   trust cards.

   WHY THIS EXISTS:
   Shopify can regenerate the section-specific template id/class.
   The approved trust styling and responsive JS were originally
   scoped to one generated identity. This bridge finds the actual
   trust section by its four customer-facing messages, then adds
   stable Gymbuild classes plus the legacy class expected by the
   existing finalized trust JS.

   This changes no trust copy and no card styling itself.
   ============================================================ */

(function () {
  const LEGACY_BANNER_CLASS =
    'highlights-banner__template--25770944135464__dynamic_highlights_banner';

  const STABLE_SECTION_CLASS =
    'gb-home-trust-section';

  const STABLE_BANNER_CLASS =
    'gb-home-trust-banner';

  const REQUIRED_TEXT = [
    'best price guarantee',
    'free shipping',
    'u.s.-based support',
    'trusted payment options'
  ];


  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function containsRequiredTrustCopy(element) {
    if (!element) return false;

    const text =
      normalizeText(
        element.textContent
      );

    return REQUIRED_TEXT.every(
      function (phrase) {
        return text.includes(phrase);
      }
    );
  }


  function findTrustSection(root = document) {
    const sections =
      Array.from(
        root.querySelectorAll?.(
          '.shopify-section, [id^="shopify-section-"]'
        ) || []
      );

    const localMatch =
      sections.find(
        containsRequiredTrustCopy
      );

    if (localMatch) {
      return localMatch;
    }


    const allSections =
      Array.from(
        document.querySelectorAll(
          '.shopify-section, [id^="shopify-section-"]'
        )
      );

    return (
      allSections.find(
        containsRequiredTrustCopy
      ) ||
      null
    );
  }


  function findTrustBanner(section) {
    if (!section) return null;

    /*
      Prefer the actual Highlights Banner wrapper when available.
      If Shopify's generated wrapper class changes, fall back to
      the closest parent of the native .highlights-banner__content.
    */

    const content =
      section.querySelector(
        '.highlights-banner__content'
      );

    if (!content) return null;


    let banner =
      content.parentElement;

    while (
      banner &&
      banner !== section &&
      !containsRequiredTrustCopy(banner)
    ) {
      banner =
        banner.parentElement;
    }


    if (
      !banner ||
      banner === section
    ) {
      banner =
        content.parentElement ||
        section;
    }

    return banner;
  }


  function restoreTrustIdentity(root = document) {
    const section =
      findTrustSection(root);

    if (!section) return;


    section.classList.add(
      STABLE_SECTION_CLASS
    );


    const banner =
      findTrustBanner(section);

    if (!banner) return;


    banner.classList.add(
      STABLE_BANNER_CLASS,
      LEGACY_BANNER_CLASS
    );
  }


  function initTrustIdentity() {
    restoreTrustIdentity(
      document
    );
  }


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initTrustIdentity,
      { once: true }
    );
  } else {
    initTrustIdentity();
  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {
      restoreTrustIdentity(
        event.target || document
      );
    }
  );

})();







































































/* ============================================================
   Gymbuild – Homepage Trust Responsive Track

   Portrait phone:
   - dedicated Meta-style horizontal scroll-snap slider

   Landscape phone:
   - same cloned cards displayed as the desktop-style four-card grid

   Tablet / desktop:
   - cloned track hidden
   - Empire's original trust content shown

   This keeps landscape phones visually consistent with the
   approved desktop trust section without allowing Empire/Flickity
   mobile behavior to interfere.
   ============================================================ */

(function () {
  const TRUST_SECTION_SELECTOR =
    '.highlights-banner__template--25770944135464__dynamic_highlights_banner';

  const CONTENT_SELECTOR =
    ':scope > .highlights-banner__content';

  const RESPONSIVE_TRACK_CLASS =
    'gb-trust-mobile-slider';

  const PORTRAIT_PHONE_QUERY =
    window.matchMedia(
      '(max-width: 749px) and (orientation: portrait)'
    );

  const LANDSCAPE_PHONE_QUERY =
    window.matchMedia(
      '(max-width: 989px) and (max-height: 749px) and (orientation: landscape)'
    );


  function setImportant(element, property, value) {
    element.style.setProperty(
      property,
      value,
      'important'
    );
  }


  function removeInlineLayout(element) {
    [
      'display',
      'flex-direction',
      'flex-wrap',
      'align-items',
      'justify-content',
      'gap',
      'grid-template-columns',
      'width',
      'min-width',
      'max-width',
      'height',
      'min-height',
      'max-height',
      'margin',
      'margin-top',
      'margin-right',
      'margin-bottom',
      'margin-left',
      'padding',
      'padding-top',
      'padding-right',
      'padding-bottom',
      'padding-left',
      'box-sizing',
      'overflow',
      'overflow-x',
      'overflow-y',
      'scroll-snap-type',
      'scroll-snap-align',
      'scroll-snap-stop',
      'scroll-padding',
      'scroll-padding-left',
      'scroll-padding-right',
      'touch-action',
      'position',
      'background',
      'background-color',
      'border',
      'border-radius',
      'box-shadow'
    ].forEach((property) => {
      element.style.removeProperty(property);
    });
  }


  function cleanTrustClone(block) {
    block.removeAttribute('style');
    block.removeAttribute('aria-hidden');
    block.removeAttribute('tabindex');

    block.classList.remove(
      'is-selected',
      'is-pointer-down'
    );

    block.setAttribute(
      'data-gb-responsive-trust-card',
      ''
    );

    return block;
  }


  function applyPortraitPhoneLayout(originalContent, track) {
    setImportant(originalContent, 'display', 'none');

    setImportant(track, 'display', 'flex');
    setImportant(track, 'flex-direction', 'row');
    setImportant(track, 'flex-wrap', 'nowrap');
    setImportant(track, 'align-items', 'stretch');
    setImportant(track, 'justify-content', 'flex-start');
    setImportant(track, 'gap', '24px');

    setImportant(track, 'width', '100%');
    setImportant(track, 'min-width', '0');
    setImportant(track, 'max-width', 'none');

    setImportant(track, 'margin-top', '0');
    setImportant(track, 'margin-bottom', '0');
    setImportant(track, 'margin-left', '0');
    setImportant(track, 'margin-right', '0');

    setImportant(track, 'padding-top', '0');
    setImportant(track, 'padding-bottom', '0');
    setImportant(track, 'padding-left', '16px');
    setImportant(track, 'padding-right', '16px');

    setImportant(track, 'box-sizing', 'border-box');

    setImportant(track, 'overflow-x', 'auto');
    setImportant(track, 'overflow-y', 'hidden');

    setImportant(track, 'scroll-snap-type', 'x mandatory');
    setImportant(track, 'scroll-padding-left', '16px');
    setImportant(track, 'scroll-padding-right', '16px');

    setImportant(track, 'touch-action', 'pan-x pan-y');


    Array.from(track.children).forEach((card) => {
      if (
        !card.classList.contains(
          'highlights-banner__block'
        )
      ) {
        return;
      }

      removeInlineLayout(card);

      setImportant(card, 'position', 'relative');

      setImportant(card, 'display', 'flex');
      setImportant(card, 'flex-direction', 'column');
      setImportant(card, 'flex-wrap', 'nowrap');

      setImportant(card, 'flex', '0 0 240px');

      setImportant(card, 'width', '240px');
      setImportant(card, 'min-width', '240px');
      setImportant(card, 'max-width', '240px');

      setImportant(card, 'height', '210px');
      setImportant(card, 'min-height', '210px');
      setImportant(card, 'max-height', '210px');

      setImportant(card, 'margin', '0');

      setImportant(
        card,
        'padding',
        '26px 22px 25px'
      );

      setImportant(card, 'box-sizing', 'border-box');

      setImportant(
        card,
        'background',
        'linear-gradient(to bottom, #F5F6F8 0%, #F5F6F8 28%, #FFFFFF 100%)'
      );
      setImportant(card, 'background-color', '#F5F6F8');

      setImportant(card, 'border', '0');
      setImportant(card, 'border-radius', '16px');

      setImportant(card, 'box-shadow', 'none');

      setImportant(card, 'overflow', 'hidden');

      setImportant(
        card,
        'scroll-snap-align',
        card === track.lastElementChild
          ? 'end'
          : 'start'
      );

      setImportant(
        card,
        'scroll-snap-stop',
        'always'
      );
    });
  }


  function applyLandscapePhoneLayout(originalContent, track) {
    setImportant(originalContent, 'display', 'none');

    setImportant(track, 'display', 'grid');

    setImportant(
      track,
      'grid-template-columns',
      'repeat(2, minmax(0, 1fr))'
    );

    setImportant(
      track,
      'grid-auto-rows',
      '1fr'
    );

    setImportant(track, 'column-gap', '24px');
    setImportant(track, 'row-gap', '24px');
    setImportant(track, 'gap', '24px');

    setImportant(track, 'width', 'calc(100% - 48px)');
    setImportant(track, 'max-width', '760px');

    setImportant(track, 'margin-top', '0');
    setImportant(track, 'margin-bottom', '0');
    setImportant(track, 'margin-left', 'auto');
    setImportant(track, 'margin-right', 'auto');

    setImportant(track, 'padding', '0');

    setImportant(track, 'box-sizing', 'border-box');

    setImportant(track, 'overflow', 'visible');

    setImportant(track, 'scroll-snap-type', 'none');
    setImportant(track, 'scroll-padding', '0');

    setImportant(track, 'touch-action', 'auto');


    Array.from(track.children).forEach((card) => {
      if (
        !card.classList.contains(
          'highlights-banner__block'
        )
      ) {
        return;
      }

      removeInlineLayout(card);

      setImportant(card, 'position', 'relative');

      setImportant(card, 'display', 'flex');
      setImportant(card, 'flex-direction', 'column');

      setImportant(card, 'align-items', 'flex-start');
      setImportant(card, 'justify-content', 'flex-start');

      setImportant(card, 'width', '100%');
      setImportant(card, 'min-width', '0');
      setImportant(card, 'max-width', 'none');

      setImportant(card, 'height', '100%');
      setImportant(card, 'min-height', '210px');
      setImportant(card, 'max-height', 'none');

      setImportant(card, 'margin', '0');

      setImportant(
        card,
        'padding',
        '26px 22px 25px'
      );

      setImportant(card, 'box-sizing', 'border-box');

      setImportant(
        card,
        'background',
        'linear-gradient(to bottom, #F5F6F8 0%, #F5F6F8 28%, #FFFFFF 100%)'
      );
      setImportant(card, 'background-color', '#F5F6F8');

      setImportant(card, 'border', '0');
      setImportant(card, 'border-radius', '16px');

      setImportant(card, 'box-shadow', 'none');

      setImportant(card, 'overflow', 'hidden');

      setImportant(card, 'scroll-snap-align', 'none');
    });
  }

  function applyResponsiveTrustLayout(section) {
    if (!section) return;

    const originalContent =
      section.querySelector(CONTENT_SELECTOR);

    const track =
      section.querySelector(
        `:scope > .${RESPONSIVE_TRACK_CLASS}`
      );

    if (!originalContent || !track) return;


    if (PORTRAIT_PHONE_QUERY.matches) {
      applyPortraitPhoneLayout(
        originalContent,
        track
      );

      return;
    }


    if (LANDSCAPE_PHONE_QUERY.matches) {
      applyLandscapePhoneLayout(
        originalContent,
        track
      );

      return;
    }


    /* Tablet / desktop: restore Empire's original trust section. */
    originalContent.style.removeProperty(
      'display'
    );

    setImportant(
      track,
      'display',
      'none'
    );
  }


  function buildResponsiveTrustTrack(root = document) {
    const section =
      root.matches?.(TRUST_SECTION_SELECTOR)
        ? root
        : (
            root.querySelector?.(
              TRUST_SECTION_SELECTOR
            ) ||
            document.querySelector(
              TRUST_SECTION_SELECTOR
            )
          );

    if (!section) return;


    const originalContent =
      section.querySelector(CONTENT_SELECTOR);

    if (!originalContent) return;


    const existingTrack =
      section.querySelector(
        `:scope > .${RESPONSIVE_TRACK_CLASS}`
      );

    if (existingTrack) {
      existingTrack.remove();
    }


    const sourceBlocks =
      Array.from(
        originalContent.querySelectorAll(
          '.highlights-banner__block'
        )
      );

    if (!sourceBlocks.length) return;


    const track =
      document.createElement('div');

    track.className =
      RESPONSIVE_TRACK_CLASS;

    track.setAttribute(
      'aria-label',
      'Why shop Gymbuild'
    );


    sourceBlocks.forEach((sourceBlock) => {
      const clone =
        cleanTrustClone(
          sourceBlock.cloneNode(true)
        );

      track.appendChild(clone);
    });


    originalContent.insertAdjacentElement(
      'afterend',
      track
    );


    applyResponsiveTrustLayout(section);
  }


  function initResponsiveTrustTrack() {
    buildResponsiveTrustTrack(document);
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initResponsiveTrustTrack,
      { once: true }
    );
  } else {
    initResponsiveTrustTrack();
  }


  /* Shopify Theme Editor support */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section =
        event.target?.matches?.(
          TRUST_SECTION_SELECTOR
        )
          ? event.target
          : event.target?.querySelector?.(
              TRUST_SECTION_SELECTOR
            );

      if (!section) return;


      window.setTimeout(
        function () {
          buildResponsiveTrustTrack(section);
        },
        50
      );
    }
  );


  function handleResponsiveModeChange() {
    const section =
      document.querySelector(
        TRUST_SECTION_SELECTOR
      );

    if (!section) return;


    if (
      !section.querySelector(
        `:scope > .${RESPONSIVE_TRACK_CLASS}`
      )
    ) {
      buildResponsiveTrustTrack(section);
      return;
    }


    applyResponsiveTrustLayout(section);
  }


  [
    PORTRAIT_PHONE_QUERY,
    LANDSCAPE_PHONE_QUERY
  ].forEach((query) => {
    if (query.addEventListener) {
      query.addEventListener(
        'change',
        handleResponsiveModeChange
      );
    } else {
      query.addListener(
        handleResponsiveModeChange
      );
    }
  });


  window.addEventListener(
    'orientationchange',
    function () {
      window.setTimeout(
        handleResponsiveModeChange,
        120
      );
    },
    { passive: true }
  );

})();




/* ============================================================
   Gymbuild – Human Contact Section Before Footer
   PRODUCT PAGES ONLY

   Uses the actual Empire footer markup:
   <footer role="contentinfo" aria-label="Footer">

   The section is inserted immediately before that footer.
   ============================================================ */
(function () {

  const SECTION_ID =
    'gb-contact-before-footer';


  function isProductPage() {
    return (
      /^\/products\/[^/]+\/?$/i.test(
        window.location.pathname
      ) ||
      document.body.classList.contains(
        'template-product'
      ) ||
      Array.from(
        document.body.classList
      ).some(
        function (className) {
          return className.indexOf(
            'template-product'
          ) !== -1;
        }
      )
    );
  }


  function getFooter() {
    return (
      document.querySelector(
        'footer[role="contentinfo"][aria-label="Footer"]'
      ) ||
      document.querySelector(
        '#shopify-section-sections--27732053426472__footer footer[role="contentinfo"]'
      ) ||
      document.querySelector(
        'footer[role="contentinfo"]'
      ) ||
      document.querySelector(
        '.site-footer-wrapper'
      )?.closest('footer')
    );
  }


  function findChatLauncherInRoot(
    root
  ) {
    if (!root) {
      return null;
    }

    const selectors = [
      'button[aria-label*="chat" i]:not([data-gb-open-chat])',
      '[role="button"][aria-label*="chat" i]:not([data-gb-open-chat])',
      'button[title*="chat" i]:not([data-gb-open-chat])',
      '[role="button"][title*="chat" i]:not([data-gb-open-chat])',
      'a[aria-label*="chat" i]:not([data-gb-open-chat])',
      'iframe[title*="chat" i]'
    ];

    for (
      const selector of selectors
    ) {
      const matches =
        root.querySelectorAll
          ? Array.from(
              root.querySelectorAll(
                selector
              )
            )
          : [];

      const visible =
        matches.find(
          function (element) {
            const rect =
              element.getBoundingClientRect
                ? element.getBoundingClientRect()
                : null;

            if (
              !rect ||
              rect.width <= 0 ||
              rect.height <= 0
            ) {
              return false;
            }

            const style =
              window.getComputedStyle(
                element
              );

            return (
              style.display !== 'none' &&
              style.visibility !== 'hidden'
            );
          }
        );

      if (visible) {
        return visible;
      }
    }

    const children =
      root.querySelectorAll
        ? root.querySelectorAll('*')
        : [];

    for (
      const child of children
    ) {
      if (
        child.shadowRoot
      ) {
        const found =
          findChatLauncherInRoot(
            child.shadowRoot
          );

        if (found) {
          return found;
        }
      }
    }

    return null;
  }


  function openExistingChat() {
    const launcher =
      findChatLauncherInRoot(
        document
      );

    if (!launcher) {
      return;
    }

    if (
      launcher.tagName ===
      'IFRAME'
    ) {
      try {
        launcher.contentWindow
          ?.document
          ?.querySelector(
            'button, [role="button"]'
          )
          ?.click();
      } catch (error) {
        /*
          Cross-origin iframe.
          No safe direct DOM access available.
        */
      }

      return;
    }

    launcher.click();
  }


  function createContactSection() {
    const section =
      document.createElement(
        'section'
      );

    section.id =
      SECTION_ID;

    section.className =
      'gb-contact-before-footer';

    section.setAttribute(
      'aria-labelledby',
      'gb-contact-before-footer-title'
    );

    section.innerHTML = `
      <div class="gb-contact-before-footer__inner">

        <div class="gb-contact-before-footer__heading">

          <h2
            id="gb-contact-before-footer-title"
          >
            Have questions?<span class="gb-contact-before-footer__mobile-break"> Get in touch!</span>
          </h2>

          <p>
            We're here before and after your order.
          </p>

        </div>


        <div class="gb-contact-before-footer__options">


          <button
            class="gb-contact-before-footer__option"
            type="button"
            data-gb-open-chat
          >

            <span
              class="gb-contact-before-footer__icon"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                focusable="false"
              >
                <path
                  d="M4 5.5h16v10H9l-5 4v-14Z"
                ></path>

                <path
                  d="M8 10.5h.01"
                ></path>

                <path
                  d="M12 10.5h.01"
                ></path>

                <path
                  d="M16 10.5h.01"
                ></path>
              </svg>
            </span>

            <span
              class="gb-contact-before-footer__label"
            >
              Live chat
            </span>

          </button>


          <a
            class="gb-contact-before-footer__option"
            href="mailto:support@gymbuild.net"
          >

            <span
              class="gb-contact-before-footer__icon"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                focusable="false"
              >
                <rect
                  x="3.5"
                  y="5.5"
                  width="17"
                  height="13"
                  rx="1.75"
                ></rect>

                <path
                  d="m4.5 7 7.5 5.5L19.5 7"
                ></path>
              </svg>
            </span>

            <span
              class="gb-contact-before-footer__label"
            >
              Email us
            </span>

          </a>


          <a
            class="gb-contact-before-footer__option"
            href="tel:+18444253710"
          >

            <span
              class="gb-contact-before-footer__icon"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                focusable="false"
              >
                <path
                  d="M7.1 3.75 10 7.6 8.1 9.5c1.25 2.55 3.25 4.55 5.8 5.8l1.9-1.9 3.85 2.9c.45.35.55.95.25 1.45l-1.15 1.9c-.3.5-.9.75-1.45.65C10.1 19 5 13.9 3.7 6.7c-.1-.55.15-1.15.65-1.45l1.9-1.15c.5-.3 1.1-.2 1.45.25Z"
                ></path>
              </svg>
            </span>

            <span
              class="gb-contact-before-footer__label"
            >
              Call us
            </span>

          </a>


        </div>

      </div>
    `;

    return section;
  }


  function insertContactSection() {
    if (
      !isProductPage()
    ) {
      return false;
    }

    if (
      document.getElementById(
        SECTION_ID
      )
    ) {
      return true;
    }

    const footer =
      getFooter();

    if (!footer) {
      return false;
    }

    footer.insertAdjacentElement(
      'beforebegin',
      createContactSection()
    );

    return true;
  }


  function init() {
    if (
      !isProductPage()
    ) {
      return;
    }

    if (
      insertContactSection()
    ) {
      return;
    }

    /*
      Empire's footer group may finish mounting after custom.js.
      Observe until the real footer exists, then stop.
    */
    const observer =
      new MutationObserver(
        function () {
          if (
            insertContactSection()
          ) {
            observer.disconnect();
          }
        }
      );

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }


  /*
    Shared chat trigger for this pre-footer section and the
    existing PDP "Talk to a Real Person" chat link.
  */
  document.addEventListener(
    'click',
    function (event) {
      if (
        !isProductPage()
      ) {
        return;
      }

      const target =
        event.target;

      const chatTrigger =
        target &&
        target.closest
          ? target.closest(
              '[data-gb-open-chat]'
            )
          : null;

      if (!chatTrigger) {
        return;
      }

      event.preventDefault();

      openExistingChat();
    }
  );


  document.addEventListener(
    'shopify:section:load',
    function () {
      if (
        !isProductPage()
      ) {
        return;
      }

      window.setTimeout(
        insertContactSection,
        0
      );
    }
  );

})();

